import ReactTooltip from "react-tooltip";
import { useParams, useHistory } from "react-router-dom";
import Table from "../../common/components/Table";
import ReactPaginate from "react-paginate";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import { useDispatch, useSelector, useStore } from "react-redux";
import moment from "moment";
import { MobileRecommendationsTableData } from "../../../config/tableData";
import { getTableConfig, saveTableConfig } from "../../common/actions";

import _, { template } from "lodash";
import LoadingOverlay from "react-loading-overlay";
import refreshIcon from "../../../assets/img/img-refresh.svg";
import Loader from "../../common/components/Loader";
import actions from "../actions";
import surveyActions from "../../assetSurveyProject/actions";
import imageActions from "../../images/actions";

import TableTopIcons from "../../common/components/TableTopIcons";
import Portal from "../../common/components/Portal";
import ViewModal from "../../common/components/ViewModal";
import {
    addTableSliderDataToBreadcrumb,
    addToBreadCrumpData,
    checkPermission,
    getCurrentAge,
    getUsefullLifeRemaining,
    normalizeToNested,
    showAlert as showAlertUtil
} from "../../../config/utils";
import AssetsForm from "../../assetSurveyProject/components/AssetsForm";
import RecommendationsMultiEdit from "../../assetSurveyProject/components/AssetsMultiEdit";
import { MyFilters } from "./FilterModal/MyFilters";
import { AppliedFilters } from "../../common/AppliedFilters";
import { DynamicColumnModal } from "../../common/DynamicColumnModal";
import { getPinnedColumnLeftPositions } from "../../../utils/tableUtils";
import { permissions } from "../../../config/permissions";
import RecommendationPreview from "../../recommendations/components/RecommendationPreview";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import assetActions from "../../assetSurveyProject/actions";
import normalAssetActions from "../../assets/actions";
import normalRecomStatusActions from "../../Status/action";
import normalRecomActions from "../../recommendations/actions";
import { customOrder, DEFALUT_BAND_VALUE, SEARCH_AND_REPLACE_REMOVED_FIELDS } from "../constants";
import projectActions from "../../project/actions";
import { autoFields, recommendationSurveyStatus, surveyTypes } from "../../assetSurveyProject/constants";
import { DYNAMIC_FIELD_TYPES } from "../../common/constants";
import MobileTableSummary from "./MobileTableSummary";
import { Dropdown } from "react-bootstrap";
import ProgressBarModal from "../../common/ProgressBarModal";
import qs from "query-string";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { TableTopMoreFilters } from "../../assetSurveyProject/components/TableTopMoreFilter";
import SearchAndReplace from "../../assetSurveyProject/components/SearchAndReplace";
import { buildAddonFilters, splitVoiceFilters } from "../../assetSurveyProject/utils";

const lineEditDisabledFields = [
    "region_id",
    "site_id",
    "building_id",
    "addition_id",
    "trade_id",
    "system_id",
    "sub_system_id",
    "category_id",
    "floor",
    "image_id",
    "parent_global_id",
    "survey_global_id",
    "survey_id"
];

const lineEditDisabledFieldSuffixes = [".image_id", ".parent_global_id", ".survey_global_id"];

const lineEditDerivedDisabledFields = [
    "current_age",
    "assets.current_age",
    "end_of_service_life",
    "assets.end_of_service_life",
    "usefull_life_remaining",
    "assets.usefull_life_remaining",
    "priority"
];

const getEndOfServiceLife = (installedYear, serviceLife) =>
    parseInt(installedYear) && parseInt(serviceLife) ? parseInt(installedYear) + parseInt(serviceLife) : "";

const lineEditFetchableDropdowns = [
    "asset_condition_id",
    "criticality_id",
    "department_id",
    "funding_source_id",
    "initiative_id",
    "main_building_type_id",
    "recommendation_capital_type_id",
    "responsibility_id"
];

// Sourced from the client-scoped assets dropdown, not the mobile recommendation service.
const lineEditManufacturerFields = ["manufacturer", "manufacturer_id", "assets.manufacturer", "assets.manufacturer_id"];

const lineEditAllowedTypes = [
    DYNAMIC_FIELD_TYPES.TEXT,
    DYNAMIC_FIELD_TYPES.MEMO,
    DYNAMIC_FIELD_TYPES.SELECT,
    DYNAMIC_FIELD_TYPES.CURRENCY,
    "text",
    "memo",
    "select",
    "custom_select",
    "string",
    "number",
    "date",
    "date_time",
    "boolean",
    "year"
];

const normalizeLineEditOption = option => {
    if (option == null) return null;
    if (typeof option === "string" || typeof option === "number" || typeof option === "boolean") {
        return { id: option, name: String(option) };
    }

    const id = option?.id ?? option?.value ?? option?.uuid ?? option?.key ?? option?.name ?? option?.label;
    // display_name first: capital types carry an abbreviation in name and the full label in display_name.
    const name = option?.display_name || option?.name || option?.label || option?.value || option?.id || option?.uuid || "";

    if (id == null && name === "") return null;
    return {
        ...option,
        id,
        name: String(name ?? "")
    };
};

const normalizeLineEditOptions = options => (Array.isArray(options) ? options.map(normalizeLineEditOption).filter(Boolean) : []);

const normalizeBooleanLineEditValue = value => {
    if (value === "" || value == null) return null;
    if (value === true || value === "true" || value === "yes" || value === "Yes" || value === 1 || value === "1") return true;
    if (value === false || value === "false" || value === "no" || value === "No" || value === 0 || value === "0") return false;
    return value;
};

const isFieldLineEditDisabledByMetadata = field => {
    const fieldName = field?.field_name;
    return (
        !fieldName ||
        lineEditDerivedDisabledFields.includes(fieldName) ||
        autoFields.includes(fieldName) ||
        field?.rules?.read_only ||
        ["calculated", "weighted_selection"].includes(field?.field_mode)
    );
};

const getTableDataWithStickyAssetLeft = (tableData, columnKey) => {
    const columnConfig = tableData?.config?.[columnKey];
    if (!columnConfig) return tableData;

    return {
        ...tableData,
        config: {
            ...tableData.config,
            [columnKey]: {
                ...columnConfig,
                style: {
                    ...columnConfig.style,
                    "--sticky-asset-left": columnConfig?.style?.left || "54px"
                }
            }
        }
    };
};

const MobileRecommendationsMain = ({ isNormalRecommendation, parentLoading = false }) => {
    const { id, section, templateId } = useParams();
    const {
        getMobileRecommendationTemplateResponse,
        updateMultiMobileRecommendation,
        getAllMobileRecommendationIdsResponse,
        mobileRecommendationEntityParams,
        updateMobileRecommendationFieldsResponse,
        getListForMobileRecommendationCommonFilterResponse,
        getMobileRecommendationsExcelLoading,
        getTableSummaryDataLoading,
        getTableSummaryDataResponse,
        getAiAnalyseKeys,
        getExcelLoading,
        getGroupEditProgressResponse: backgroundTaskProgressResponse,
        convertedMobileRecommendationEntityParams,
        searchAndReplaceMobileRecomLoading,
        searchAndReplaceMobileRecomResponse,
        findMobileRecomBeforeReplacingLoading,
        findMobileRecomBeforeReplacingResponse,
        appliedFilterNames
    } = useSelector(state => state.mobileRecommendationsReducer);
    const store = useStore();
    const { search } = useLocation();
    const query = qs.parse(search);

    const isConvertedMobileRecom = qs.parse(search)?.is_mr === "true";

    const entityParamsCheck =
        (id ?? templateId) ===
            (isConvertedMobileRecom ? convertedMobileRecommendationEntityParams?.currentId : mobileRecommendationEntityParams?.currentId) ||
        window.location.pathname.startsWith("/mobrecoms/");

    const [basicDetails, setBasicDetails] = useState(DEFALUT_BAND_VALUE ?? {});
    const [alertMessage, setAlertMessage] = useState("");
    const [incompletedRecoms, setIncompletedRecoms] = useState(
        entityParamsCheck
            ? ((isConvertedMobileRecom
                  ? convertedMobileRecommendationEntityParams?.incompletedRecoms
                  : mobileRecommendationEntityParams?.incompletedRecoms) ?? 0)
            : 0
    );
    const [showMultiSelectEditForm, setShowMultiSelectEditForm] = useState(false);
    const [selectedRecomIds, setSelectedRecomIds] = useState(
        entityParamsCheck
            ? ((isConvertedMobileRecom
                  ? convertedMobileRecommendationEntityParams?.selectedRecomIds
                  : mobileRecommendationEntityParams?.selectedRecomIds) ?? [])
            : []
    );
    const [showFiltersPopup, setShowFiltersPopup] = useState(false);
    const [showAppliedFilters, setShowAppliedFilters] = useState(false);
    const multiEditRef = useRef(null);
    const history = useHistory();
    const { getMobileRecommendationsResponse, getRecommendationByIdResponse } = useSelector(state => state.recommendationsReducer);
    const { getDataByIdResponse } = useSelector(state => state.assetReducer);
    const { getProjectByIdResponse } = useSelector(state => state.projectReducer);

    const { getSurveyRecommendationsImagesById, assetTableAiAnalysisClick } = useSelector(state => state.assetSurveyProjectReducer);
    const previewImageList = useMemo(
        () => ({
            images: [
                ...(getSurveyRecommendationsImagesById?.data?.image ?? []),
                ...(getSurveyRecommendationsImagesById?.data?.added_image ?? [])
            ]
        }),
        [getSurveyRecommendationsImagesById]
    );
    const { getMobileRecommendationByIdResponse } = useSelector(state => state.mobileRecommendationsReducer);
    const [tableData, setTableData] = useState({
        ...MobileRecommendationsTableData,
        config: entityParamsCheck
            ? isConvertedMobileRecom
                ? (convertedMobileRecommendationEntityParams?.tableConfig ?? {})
                : (mobileRecommendationEntityParams?.tableConfig ?? {})
            : MobileRecommendationsTableData?.config,
        keys: entityParamsCheck
            ? isConvertedMobileRecom
                ? (convertedMobileRecommendationEntityParams?.tableKeys ?? [])
                : (mobileRecommendationEntityParams?.tableKeys ?? [])
            : MobileRecommendationsTableData?.keys
    });
    const [paginationParams, setPaginationParams] = useState(
        entityParamsCheck
            ? isConvertedMobileRecom
                ? convertedMobileRecommendationEntityParams?.paginationParams
                : (mobileRecommendationEntityParams?.paginationParams ?? {})
            : {
                  totalPages: 0,
                  perPage: 40,
                  currentPage: 0,
                  totalCount: 0
              }
    );
    const [params, setParams] = useState(
        entityParamsCheck
            ? isConvertedMobileRecom
                ? convertedMobileRecommendationEntityParams?.params
                : (mobileRecommendationEntityParams?.params ?? {})
            : {
                  limit: 40,
                  offset: 0,
                  search: "",
                  filters: null,
                  filterKeys: null,
                  list: null,
                  order: null,
                  image_or_not: null,
                  me: null,
                  recommendation_ids: []
              }
    );
    const [configChanged, setConfigChanged] = useState(false);
    const [showWildCardFilter, setShowWildCardFilter] = useState(false);
    const statusUpdateRef = useRef(false);
    const [selectedRowId, setSelectedRowId] = useState(entityParamsCheck ? (mobileRecommendationEntityParams?.selectedRowId ?? []) : []);
    const pinnedColumnsRef = {};
    const [showViewModal, setShowViewModal] = useState(false);
    const [initialTableConfig, setInitialTableConfig] = useState(
        (isConvertedMobileRecom ? convertedMobileRecommendationEntityParams?.currentId : mobileRecommendationEntityParams?.currentId) ===
            (id ?? templateId) || window.location.pathname.startsWith("/mobrecoms/")
            ? (isConvertedMobileRecom ? convertedMobileRecommendationEntityParams?.tableConfig : mobileRecommendationEntityParams.tableConfig) ||
                  _.cloneDeep(MobileRecommendationsTableData.config)
            : _.cloneDeep(MobileRecommendationsTableData.config)
    );
    const [initialKeys, setInitialKeys] = useState(null);
    const [tableLoading, setTableLoading] = useState(false);
    const [paneViewEnabled, setPaneViewEnabled] = useState(
        (isConvertedMobileRecom ? convertedMobileRecommendationEntityParams?.paneViewEnabled : mobileRecommendationEntityParams?.paneViewEnabled) ??
            false
    );
    const hadStoredPaneState = useRef(
        entityParamsCheck &&
            (isConvertedMobileRecom
                ? convertedMobileRecommendationEntityParams?.paneViewEnabled
                : mobileRecommendationEntityParams?.paneViewEnabled) !== undefined
    );
    const [selectedPreviewId, setSelectedPreviewId] = useState(
        isConvertedMobileRecom ? convertedMobileRecommendationEntityParams?.selectedPreviewId : mobileRecommendationEntityParams.selectedPreviewId
    );
    const [showAnalysisConfirm, setAnalysisConfirmation] = useState(false);
    const [projectId, setProjectId] = useState(null);
    const [showTableSummary, setShowTableSummary] = useState(false);
    const [showExcelPopup, setShowExcelPopup] = useState(null);
    const [surveyExport, setSurveyExport] = useState(false);
    const [aiAnalyseKey, setAIAnalyseKey] = useState({ keys: [], config: [] });
    const [progressBarModal, setProgressBarModal] = useState(false);
    const [showGlobalSearchField, setShowGlobalSearchField] = useState(
        (isConvertedMobileRecom ? convertedMobileRecommendationEntityParams?.params?.search : mobileRecommendationEntityParams?.params?.search)
            ? true
            : false
    );
    const [searchField, setSearchField] = useState(null);
    const [highlightSearchField, setHighlightSearchField] = useState(null);
    const [showMoreFilter, setShowMoreFilter] = useState(false);
    const [showSearchAndReplaceModal, setShowSearchAndReplaceModal] = useState(false);
    const [searchReplaceTaskIds, setSearchReplaceTaskIds] = useState([]);
    const [pendingFindParams, setPendingFindParams] = useState(null);
    const searchReplaceTaskId = searchReplaceTaskIds?.[0] ?? null;
    const [activeTaskId, setActiveTaskId] = useState(null);
    const [lineEditingEnabled, setLineEditingEnabled] = useState(
        entityParamsCheck
            ? !!(isConvertedMobileRecom
                  ? convertedMobileRecommendationEntityParams?.lineEditingEnabled
                  : mobileRecommendationEntityParams?.lineEditingEnabled)
            : false
    );
    const [isInputMode, setIsInputMode] = useState({});
    const [lineEditDropdownValue, setLineEditDropdownValue] = useState(null);
    const [isDropdownLoading, setIsDropdownLoading] = useState(null);
    const dispatch = useDispatch();
    let role = localStorage.getItem("role");
    const prevAIDataRef = useRef(null);
    const tableRef = useRef(null);
    const tableKeyRef = useRef(null);
    const intervalRef = useRef(null);
    const dropdownCacheRef = useRef({});
    const lineEditFocusRef = useRef(null);
    const lineEditRefreshRef = useRef(null);
    const isSurveybasedRecoms = query?.is_assignedRecom === "true";
    let user_role = localStorage.getItem("role");
    const projectManagementEditPermission =
        (checkPermission("forms", "mobile_recommendations", "edit") &&
            (user_role === "super_admin" ? true : !checkPermission("forms", "recom_mgmt_mobile", "view"))) ||
        (checkPermission("forms", "recom_mgmt_mobile", "edit") &&
            checkPermission("forms", "recom_mgmt_mobile", "view") &&
            checkPermission("forms", "mobile_recommendations", "view") &&
            checkPermission("forms", "mobile_recommendations", "edit"));

    useEffect(() => {
        // dispatch(projectActions?.getProjectById(id));
        return () => {
            dispatch(actions.resetReducer());
            dispatch(actions.resetForm());
            dispatch(
                actions?.udpateScrollPosition(tableRef?.current?.scrollLeft, qs.parse(search)?.is_mr === "true" ? "convertedMobileRec" : "mobileRec")
            );
            dispatch(actions?.resetGroupEditReducer());
        };
    }, []);

    useEffect(() => {
        if (!entityParamsCheck) {
            resetAll();
            setTableData({
                config: _.cloneDeep(MobileRecommendationsTableData?.config),
                keys: MobileRecommendationsTableData?.keys,
                data: []
            });
        }
    }, [entityParamsCheck]);

    useEffect(() => {
        if (params?.image_or_not) setShowMoreFilter(true);
    }, [params?.image_or_not]);

    useEffect(() => {
        if ((id || query?.pid) && section !== "edit") refreshRecommendationsList();
    }, [
        id,
        query?.pid,
        params.limit,
        params.offset,
        params.search,
        params.order,
        params.filters,
        JSON.stringify(params?.recommendation_ids),
        params?.list,
        params?.me,
        params?.image_or_not,
        params?.findParams,
        templateId
    ]);

    useEffect(() => {
        if (
            (section === "recommendationsinfo" && getRecommendationByIdResponse?.project?.id) ||
            (section !== "recommendationsinfo" && section !== "assetInfo" && (id ?? query?.pid))
        ) {
            dispatch(
                actions.getMobileRecommendationTemplate(
                    section === "recommendationsinfo" ? getRecommendationByIdResponse?.project?.id : (id ?? query?.pid)
                )
            );
            if (section === "recommendationsinfo" && getRecommendationByIdResponse?.project?.id) refreshRecommendationsList();
            if (section !== "edit")
                dispatch(
                    projectActions?.getProjectById(
                        section === "recommendationsinfo" ? getRecommendationByIdResponse?.project?.id : (id ?? query?.pid)
                    )
                );
        }
    }, [id, getRecommendationByIdResponse, query?.pid]);
    useEffect(() => {
        if (section === "assetInfo" && (getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid)) {
            dispatch(
                actions.getMobileRecommendationTemplate(section === "assetInfo" ? (getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid) : id)
            );
            if (section === "assetInfo" && (getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid)) refreshRecommendationsList();
            dispatch(projectActions?.getProjectById(section === "assetInfo" ? (getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid) : id));
        }
    }, [id, getDataByIdResponse, qs.parse(search)?.pid]);

    useEffect(() => {
        dispatch(actions?.getAiAnalyseKey());
    }, []);
    useEffect(() => {
        if (getMobileRecommendationsResponse?.task?.id) setActiveTaskId(getMobileRecommendationsResponse.task.id);
    }, [getMobileRecommendationsResponse?.task?.id]);

    useEffect(() => {
        if (updateMultiMobileRecommendation?.data?.task_id) setActiveTaskId(updateMultiMobileRecommendation.data.task_id);
    }, [updateMultiMobileRecommendation?.data?.task_id]);

    useEffect(() => {
        if (searchReplaceTaskId) setActiveTaskId(searchReplaceTaskId);
    }, [searchReplaceTaskId]);

    useEffect(() => {
        if (activeTaskId) dispatch(actions?.getGroupEditProgress(activeTaskId));
    }, [activeTaskId]);

    useEffect(() => {
        const { id: progressTaskId, status, result } = backgroundTaskProgressResponse?.data ?? {};
        const isTaskDone = [3, 4].includes(status) || Number(result?.data_update_percent ?? 0) >= 100;
        if (!searchReplaceTaskId || progressTaskId !== searchReplaceTaskId || !isTaskDone) return;
        if (status === 4) setAlertMessage("Search and replace failed for some of the recommendations");
        const remainingTaskIds = searchReplaceTaskIds.slice(1);
        setSearchReplaceTaskIds(remainingTaskIds);
        if (!remainingTaskIds?.length) applyFindParamsAfterReplace(pendingFindParams?.findParams ?? null);
    }, [backgroundTaskProgressResponse]);

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            const progress = backgroundTaskProgressResponse?.data?.result?.data_update_percent ?? 0;
            if (Number(progress) < 100 && backgroundTaskProgressResponse?.success && Number(backgroundTaskProgressResponse?.data?.status) !== 4) {
                if (activeTaskId) dispatch(actions?.getGroupEditProgress(activeTaskId));
            } else {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }, 10000);

        return () => clearInterval(intervalRef.current);
    }, [backgroundTaskProgressResponse]);

    useEffect(() => {
        if (getAiAnalyseKeys) {
            (async () => {
                await new Promise(resolve => setTimeout(resolve, 1));
                const backendData = getAiAnalyseKeys?.data;
                if (_.isEqual(prevAIDataRef.current, backendData)) return;
                if (Array.isArray(backendData) && backendData.length > 0) {
                    setTableLoading(true);

                    let tempKeys = [];
                    let tempConfig = {};

                    backendData.forEach(eachField => {
                        const insertBeforeIndex = tempKeys.findIndex(item => item === "remote_id");
                        const fieldName = eachField?.field_name || "";

                        if (insertBeforeIndex >= 0) {
                            tempKeys.splice(insertBeforeIndex, 0, fieldName);
                        } else {
                            tempKeys.push(fieldName);
                        }

                        tempConfig[fieldName] = {
                            isVisible:
                                initialTableConfig?.tableConfig?.[fieldName]?.isVisible === false
                                    ? false
                                    : eachField?.rules?.table_default_visible === false
                                      ? false
                                      : true,
                            label: eachField?.label,
                            class: "width-230px",
                            searchKey:
                                fieldName === "analyze_status"
                                    ? `survey_recommendations.${fieldName}`
                                    : `ai_analyze_images.ai_flat_json.${fieldName}`,
                            type: eachField?.field_type,
                            hasWildCardSearch: true,
                            hasCommonSearch: true,
                            getListTable:
                                fieldName === "analyze_status"
                                    ? `survey_recommendations.${fieldName}`
                                    : `ai_analyze_images.ai_flat_json.${fieldName}`,
                            commonSearchKey: "survey_form_for_asset",
                            commonSearchObjectKey: fieldName,
                            isDynamicField: false,
                            rules: eachField?.rules,
                            pinned: !!initialTableConfig?.tableConfig?.[fieldName]?.pinned,
                            style: initialTableConfig?.tableConfig?.[fieldName]?.style ?? eachField?.style,
                            hasColumnSort: true
                        };
                    });

                    tempKeys = _.uniq(tempKeys);
                    prevAIDataRef.current = backendData;
                    setAIAnalyseKey({ keys: tempKeys, config: tempConfig });
                }

                setTableLoading(false);
            })();
        }
    }, [getAiAnalyseKeys]);

    useEffect(() => {
        let tempKeys = [...tableData.keys];
        let tempConfig = { ...tableData.config };
        let tempList = getMobileRecommendationsResponse?.survey_recommendations_data ?? [];
        let totalCount = 0;
        if (getMobileRecommendationTemplateResponse?.survey_recommendation_template?.dynamic_fields) {
            let dynamic_fields = Object.entries(getMobileRecommendationTemplateResponse.survey_recommendation_template.dynamic_fields)
                .sort(([bandA, dataA], [bandB, dataB]) => dataA?.index - dataB?.index)
                .reduce((acc, [key, data]) => {
                    acc = [
                        ...acc,
                        (data.fields ?? [])
                            .map(eachField => Object.values(eachField)[0])
                            .sort((fieldA, fieldB) => fieldA.index - fieldB.index)
                            .reduce((acc, item) => {
                                acc[String(item?.field_name)] = item;
                                return acc;
                            }, {})
                    ];
                    return acc;
                }, []);
            if (aiAnalyseKey?.keys?.length && aiAnalyseKey?.config) {
                aiAnalyseKey?.keys?.forEach(fieldName => {
                    const indexToInsertBefore = tempKeys.findIndex(item => item === "remote_id");
                    if (!tempKeys.includes(fieldName)) {
                        if (indexToInsertBefore >= 0) {
                            tempKeys.splice(indexToInsertBefore, 0, fieldName);
                        } else {
                            tempKeys.push(fieldName);
                        }
                    }

                    tempConfig[fieldName] = {
                        ...aiAnalyseKey.config[fieldName]
                    };
                });
            }
            Object.values(dynamic_fields ?? {}).forEach((eachBand, i) => {
                Object.values(eachBand).forEach(eachField => {
                    let indexToInsertBefore = tempKeys.findIndex(item => item === "comments");
                    tempKeys.splice(indexToInsertBefore, 0, eachField?.field_name || "");
                    const isDropdownField = ["select", "boolean", "custom_select"].includes(eachField?.field_type);
                    const allowLineEdit =
                        !lineEditDisabledFields.includes(eachField?.field_name) &&
                        !lineEditDisabledFieldSuffixes.some(suffix => eachField?.field_name?.endsWith(suffix)) &&
                        !isFieldLineEditDisabledByMetadata(eachField) &&
                        lineEditAllowedTypes.includes(eachField?.field_type);
                    tempConfig[eachField?.field_name] = {
                        isVisible: (
                            isConvertedMobileRecom
                                ? convertedMobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.isVisible === false
                                : mobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.isVisible === false
                        )
                            ? false
                            : eachField?.rules?.table_default_visible === false
                              ? false
                              : true,
                        label: eachField?.label,
                        class: "width-230px",
                        searchKey: `dynamic_fields.${eachField?.field_name}`,
                        type: eachField?.field_type,
                        hasWildCardSearch: eachField?.field_type !== "boolean",
                        hasCommonSearch: true,
                        getListTable: `dynamic_fields.${eachField?.field_name}`,
                        commonSearchKey: "dynamic_fields",
                        commonSearchObjectKey: eachField?.field_name,
                        isDynamicField: true,
                        rules: eachField?.rules,
                        hasLineEdit: allowLineEdit,
                        isDropdownLineEdit: allowLineEdit && isDropdownField,
                        isMemoField: eachField?.field_type === DYNAMIC_FIELD_TYPES.MEMO,
                        hasSearchFunction: lineEditManufacturerFields.includes(eachField?.field_name),
                        // Priority element fields are named by GUID, so detect them by marker.
                        isPriorityElement: "priority_element_option" in (eachField ?? {}) || eachField?.recom_priority_index != null,
                        options: normalizeLineEditOptions(eachField?.field_options ?? eachField?.options),
                        pinned: (
                            isConvertedMobileRecom
                                ? convertedMobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.pinned
                                : mobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.pinned
                        )
                            ? true
                            : false,
                        style: (
                            isConvertedMobileRecom
                                ? convertedMobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.style
                                : mobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.style
                        )
                            ? isConvertedMobileRecom
                                ? convertedMobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.style
                                : mobileRecommendationEntityParams?.tableConfig?.[eachField?.field_name]?.style
                            : eachField?.style
                    };
                });
            });
            const hiddenFields = [
                "assets.usefull_life_remaining",
                "assets.service_life",
                "assets.installed_year",
                "assets.client_asset_condition_id",
                "mobile_recomm_notes_temp"
            ];
            const tempData = (tempKeys || [])?.filter(f => !hiddenFields?.includes(f));
            tempKeys = _.uniq(tempData);
            const orderedKeys = customOrder.filter(key => tempKeys?.includes(key));
            const remainingKeys = tempKeys?.filter(key => !customOrder.includes(key));
            tempKeys = [...orderedKeys, ...remainingKeys];
            if (!initialKeys) setInitialKeys([...tempKeys]);
        }
        if (getMobileRecommendationsResponse?.success) {
            tempList = tempList?.map(e => {
                const { dynamic_fields = {} } = e;
                let dynamicFields = {};
                Object.values(dynamic_fields).forEach(field => {
                    const key = field?.field_name;
                    const { value, uuid = "", label, invalid = false } = field ?? {};
                    dynamicFields = { ...dynamicFields, [key]: { value, uuid, label, invalid } };
                });

                return { ...e, dynamic_fields: dynamicFields };
            });

            tempList = tempList?.map(e => {
                const { ai_response = {} } = e;
                const ai_fields = Object.entries(ai_response || {}).reduce((acc, [key, value]) => {
                    if (key) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});

                return { ...e, ...ai_fields };
            });

            totalCount = getMobileRecommendationsResponse ? getMobileRecommendationsResponse?.count || 0 : 0;

            (tempList ?? []).forEach(temp => {
                temp.updated_at = moment(temp.updated_at).format("MM-DD-YYYY h:mm A");
                temp.created_at = moment(temp.created_at).format("MM-DD-YYYY h:mm A");
                temp.surveyed_time = moment(temp?.surveyed_time).format("MM-DD-YYYY h:mm A");
                temp.synced_time = moment(temp?.synced_time).format("MM-DD-YYYY h:mm A");
            });
        }
        const hiddenFields = [
            "assets.usefull_life_remaining",
            "assets.service_life",
            "assets.installed_year",
            "assets.client_asset_condition_id",
            "mobile_recomm_notes_temp"
        ];
        const tempData = tempKeys?.filter(f => !hiddenFields?.includes(f));
        tempKeys = _.uniq(tempData);
        const orderedKeys = customOrder.filter(key => tempKeys?.includes(key));
        const remainingKeys = tempKeys?.filter(key => !customOrder.includes(key));
        tempKeys = [...orderedKeys, ...remainingKeys];

        Object.keys(tempConfig || {})?.forEach(key => {
            if (hiddenFields?.includes(key)) {
                delete tempConfig?.[key];
            }
        });
        if (getMobileRecommendationsResponse?.success && getMobileRecommendationTemplateResponse?.survey_recommendation_template?.dynamic_fields)
            setTableDataConfigBasedOnProject(tempKeys, tempConfig, tempList);
        else setTableData({ ...tableData, config: { ...tempConfig }, keys: [...tempKeys], data: [...tempList] });
        setInitialTableConfig({ ...tempConfig });
        setPaginationParams({ ...paginationParams, totalCount, totalPages: Math.ceil(totalCount / paginationParams.perPage) });

        if (getMobileRecommendationsResponse?.message && assetTableAiAnalysisClick) {
            if (getMobileRecommendationsResponse?.ai_analyze) {
                setAlertMessage(getMobileRecommendationsResponse?.message ?? "");
                // setSelectedRecomIds([]);
            }
            dispatch(surveyActions?.assetTableAiAnalyse(false));
        }
        if (getMobileRecommendationsResponse?.detail) setAlertMessage(getMobileRecommendationsResponse?.detail);
    }, [getMobileRecommendationsResponse, getMobileRecommendationTemplateResponse, aiAnalyseKey?.keys]);

    useEffect(() => {
        if (paneViewEnabled && selectedPreviewId) {
            getAllImageList();
        }
    }, [paneViewEnabled, selectedPreviewId]);

    const setTableDataConfigBasedOnProject = async (keys, tableConfig, data) => {
        let tempConfig;
        setParams({ ...params, isConfigLoading: true });
        const config = await getTableConfig({
            user_id: localStorage.getItem("userId"),
            project_id: section === "recommendationsinfo" ? getRecommendationByIdResponse?.project?.id : (id ?? query?.pid),
            table_type: "MR-RECOMMENDATIONS"
        });

        setParams({ ...params, isConfigLoading: false });

        setConfigChanged(config?.data?.table_settings ? true : false);

        const backendConfig = config?.data?.table_settings?.config;
        tempConfig = { ...tableConfig };
        Object.keys(tempConfig ?? {}).forEach(key => {
            tempConfig[key] = {
                ...tempConfig[key],
                style: backendConfig?.[key]?.style ?? tempConfig[key]?.style,
                isVisible: backendConfig?.[key]?.isVisible ?? tempConfig[key]?.isVisible,
                pinned: backendConfig?.[key]?.pinned ?? tempConfig[key]?.pinned
            };
        });
        setTableData({
            ...tableData,
            keys: config?.data?.table_settings?.keys ? _.uniq([...config?.data?.table_settings?.keys, ...(keys ?? [])]) : (keys ?? initialKeys),
            config: tempConfig ?? initialTableConfig,
            data: config?.data?.table_settings?.data ? config?.data?.table_settings?.data : (data ?? [])
        });
        if (!hadStoredPaneState.current) setPaneViewEnabled(config?.data?.table_settings?.paneViewEnabled ?? false);
        updateEntityParams();
    };
    // useEffect(() => {
    //     if (tableRef.current && tableRef?.current?.scrollLeft !== null && !_.isEqual(tableKeyRef.current, tableData?.keys) && entityParamsCheck) {
    //         tableKeyRef.current = tableData?.keys;
    //         tableRef.current.scrollTo({
    //             left: isConvertedMobileRecom
    //                 ? convertedMobileRecommendationEntityParams?.scrollPosition
    //                 : mobileRecommendationEntityParams?.scrollPosition ?? 0,
    //             behavior: "instant"
    //         });
    //     }
    // }, [mobileRecommendationEntityParams?.scrollPosition, tableData?.keys]);

    const resetAllTableConfig = async () => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        saveUserTableConfig(null, null, true);
        setTableData({ ...tableData, keys: initialKeys, config: initialTableConfig });
        setTableLoading(false);
    };

    const saveUserTableConfig = async (keys, config, isReset, isPaneClicked = paneViewEnabled) => {
        await saveTableConfig({
            user_id: localStorage.getItem("userId"),
            project_id: section === "recommendationsinfo" ? getRecommendationByIdResponse?.project?.id : (id ?? query?.pid),
            table_type: "MR-RECOMMENDATIONS",
            table_settings: isReset ? null : { keys: keys || tableData.keys, config: config || tableData.config, paneViewEnabled: isPaneClicked }
        });

        setConfigChanged(isReset ? false : true);
    };

    const handleSurveyAssetStatus = (value, rowId) => {
        statusUpdateRef.current = true;
        dispatch(actions?.updateMobileRecommendationFields(rowId, { status: value }));
    };

    const onPaneViewClick = () => {
        setPaneViewEnabled(!paneViewEnabled);
        setSelectedPreviewId(!paneViewEnabled ? selectedRowId : null);
        saveUserTableConfig(tableData?.keys, tableData?.config, false, !paneViewEnabled);
    };
    const onPaneViewClose = () => {
        setSelectedPreviewId(null);
    };

    const updateEntityParams = async (hasScrollSave = false) => {
        let entityParams = {
            paginationParams: paginationParams,
            params: params,
            tableConfig: tableData.config,
            selectedRowId: selectedRowId,
            tableKeys: tableData.keys,
            currentId:
                section !== "projectinfo" && !isConvertedMobileRecom && !isSurveybasedRecoms
                    ? mobileRecommendationEntityParams?.currentId
                    : (id ?? templateId),
            selectedRecomIds,
            incompletedRecoms,
            selectedPreviewId,
            paneViewEnabled,
            lineEditingEnabled,
            scrollPosition: !entityParamsCheck
                ? 0
                : hasScrollSave
                  ? tableRef?.current?.scrollLeft
                  : isConvertedMobileRecom
                    ? convertedMobileRecommendationEntityParams?.scrollPosition
                    : (mobileRecommendationEntityParams?.scrollPosition ?? 0)
        };
        dispatch(
            actions.updateSurveyRecommendationEntityParams(entityParams, qs.parse(search)?.is_mr === "true" ? "convertedMobileRec" : "mobileRec")
        );
    };

    const showAlert = () => {
        showAlertUtil(alertMessage);
        setTimeout(() => setAlertMessage(""), 3000);
    };

    useEffect(() => {
        alertMessage && showAlert();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alertMessage]);

    useEffect(() => {
        if (section === "edit") return;
        updateEntityParams();
    }, [
        params,
        paginationParams,
        tableData.config,
        selectedRowId,
        selectedRecomIds,
        incompletedRecoms,
        selectedPreviewId,
        paneViewEnabled,
        templateId,
        lineEditingEnabled
    ]);

    useEffect(() => {
        if (section === "edit") {
            dispatch(actions.getMobileRecommendationById(id));
            dispatch(
                assetActions.getAssetVoiceNotes(id, {
                    page_type: "recommendations",
                    sort: "desc"
                })
            );
        }
    }, []);

    useEffect(() => {
        if (
            getMobileRecommendationByIdResponse?.recommendation?.dynamic_fields &&
            getMobileRecommendationByIdResponse?.recommendation?.dynamic_band
        ) {
            setProjectId(getMobileRecommendationByIdResponse?.recommendation?.project?.id);
            setBasicDetails({
                ...combineAndGroupFields(
                    getMobileRecommendationByIdResponse?.recommendation?.dynamic_fields,
                    getMobileRecommendationByIdResponse?.recommendation?.dynamic_band
                ),
                check_list: normalizeToNested(getMobileRecommendationByIdResponse?.recommendation?.check_list ?? []),
                has_check_list: getMobileRecommendationByIdResponse?.recommendation?.has_check_list ?? false
            });
        }
    }, [getMobileRecommendationByIdResponse]);

    useEffect(() => {
        if (multiEditRef?.current && updateMultiMobileRecommendation) {
            multiEditRef.current = false;
            const { success, message, detail = null, error } = updateMultiMobileRecommendation;
            if (success) {
                setShowMultiSelectEditForm(false);
                setProgressBarModal(true);
            } else {
                setAlertMessage(typeof detail === "string" ? detail : typeof detail === "string" ? detail : error);
            }
        }
    }, [updateMultiMobileRecommendation]);

    useEffect(() => {
        if (getAllMobileRecommendationIdsResponse) {
            const { success, message, detail = null, error } = getAllMobileRecommendationIdsResponse;
            if (success) {
                const { recommendation_id = [], count = 0 } = getAllMobileRecommendationIdsResponse?.data ?? {};
                setIncompletedRecoms(count);
                setSelectedRecomIds(recommendation_id);
            } else {
                setAlertMessage(typeof detail === "string" ? detail : (message ?? error));
            }
        }
    }, [getAllMobileRecommendationIdsResponse]);

    useEffect(() => {
        if (statusUpdateRef?.current && updateMobileRecommendationFieldsResponse) {
            statusUpdateRef.current = false;
            const { success, message, detail = null } = updateMobileRecommendationFieldsResponse;
            if (success) {
                setAlertMessage("Mobile recommendation updated successfully");
                refreshRecommendationsList();
            } else {
                setAlertMessage(typeof detail === "string" ? detail : message);
            }
        }
    }, [updateMobileRecommendationFieldsResponse]);

    const applyFindParamsToMobileRecomParams = (requestParams, findParams) => {
        const { find, replace_fields = [] } = findParams ?? {};
        if (!find || !replace_fields?.length) return requestParams;

        let filterKey = "contains";
        if (findParams?.match_case && findParams?.match_entire_cell) {
            filterKey = "string_equals";
        } else if (findParams?.match_case) {
            filterKey = "match_case";
        } else if (findParams?.match_entire_cell) {
            filterKey = "match_entire_cell";
        }

        let nextParams = { ...requestParams };
        replace_fields.forEach(field => {
            const jsonbKey = field?.startsWith("dynamic_fields.") ? field : `dynamic_fields.${field}`;
            nextParams = {
                ...nextParams,
                jsonb_filters: {
                    ...(nextParams?.jsonb_filters ?? {}),
                    [jsonbKey]: { filters: [filterKey], key: find }
                }
            };
        });

        const searchOperator = findParams?.search_operator === "AND" ? "AND" : "OR";
        return { ...nextParams, search_operator: searchOperator };
    };

    const buildMobileRecomListParams = (isAnalysis = false) => {
        let { limit, offset, search: globalSearch, order, filters, recommendation_ids = [], list = {}, idList = {} } = params;
        let mobRecommendationFilterQuery =
            section === "recommendationsinfo"
                ? { "survey_recommendations.project_id": { filters: ["string_equals"], key: getRecommendationByIdResponse?.project?.id } }
                : section === "assetInfo"
                  ? {
                        "survey_recommendations.project_id": {
                            filters: ["string_equals"],
                            key: getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid
                        }
                    }
                  : {
                        "survey_recommendations.project_id": { filters: ["string_equals"], key: id || query.pid },
                        ...(isSurveybasedRecoms
                            ? { "survey_recommendations.recommendation_survey_project_id": { filters: ["string_equals"], key: templateId } }
                            : {})
                    };
        list = { ...idList, ...list };
        // Voice transcript keys go to addon_filters, never to list / filters / jsonb_filters
        const { list: nonVoiceList, filters: nonVoiceFilters, addon: voiceAddon } = splitVoiceFilters({ list, filters });
        list = nonVoiceList;
        filters = nonVoiceFilters;
        let jsonb_filters;
        let jsonb_order;
        let jsonb_list;
        let assetType;
        let isConverted;

        const isDynamic = field => ["dynamic_fields"].includes(field?.split(".")?.[0]);

        Object.keys(list ?? {}).forEach(eachField => {
            if (isDynamic(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });
        const isAiFields = field => ["ai_flat_json"].includes(field?.split(".")?.[1]);
        Object.keys(list ?? {}).forEach(eachField => {
            if (isAiFields(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });
        let formattedList;
        Object.entries(list ?? {}).forEach(([key, value]) => {
            const field = key?.split(".")?.[0];
            const objectKey = key?.split(".")?.[1];
            if (field === "converted_or_not_converted") {
                isConverted = value?.length === 2 ? undefined : { converted_or_not_converted: value.includes("converted") };
            } else if (field === "status" || field === "has_new_val" || field === "survey_type") {
                formattedList = {
                    ...(formattedList ?? {}),
                    survey_recommendations: {
                        ...(formattedList?.survey_recommendations ?? {}),
                        [field]: [
                            ...(formattedList?.survey_recommendations?.[field] ?? []),
                            ...(field === "has_new_val" ? (value ?? [])?.map(v => v?.includes("With new field")) : value?.map(e => parseInt(e)))
                        ]
                    }
                };
            } else {
                formattedList = {
                    ...(formattedList ?? {}),
                    [field]: {
                        ...(formattedList?.[field] ?? {}),
                        [objectKey]: value
                    }
                };
            }
        });
        if (Object.keys(filters ?? {}).length) {
            Object.keys(filters).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_filters = { ...(jsonb_filters ?? {}), [e]: filters?.[e] };
                    const { [e]: omit, ...restFilters } = filters;
                    filters = { ...restFilters };
                }
            });
        }

        if (Object.keys(order ?? {}).length) {
            Object.keys(order).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_order = { ...(jsonb_order ?? {}), [e]: order?.[e] };
                    const { [e]: omit, ...restFilters } = order;
                    order = { ...restFilters };
                }
            });
        }

        let assetSurveyProjectParams = {
            search: globalSearch,
            order: order ?? {},
            limit,
            offset: offset + 1,
            filters: { ...mobRecommendationFilterQuery, ...filters },
            list: formattedList,
            jsonb_list,
            jsonb_filters,
            jsonb_order,
            ...(isAnalysis ? { ...(selectedRecomIds?.length ? { selected_ids: selectedRecomIds ?? [] } : {}), ai_analyze: "yes" } : {}),
            ...(section === "recommendationsinfo" && { recommendation_id: id }),
            ...(!isSurveybasedRecoms ? { view_from: "projects" } : {}),
            ...(section === "assetInfo" && { asset_id: id }),
            ...(params?.image_or_not ? { image_or_not: params?.image_or_not } : {})
        };

        if (recommendation_ids?.length) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(formattedList ?? {}), survey_recommendations: { id: recommendation_ids } }
            };
        }

        if (params?.me) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(assetSurveyProjectParams?.list ?? {}), users: { id: [params.me] } }
            };
        }

        // if (assetType?.length === 1) {
        //     assetSurveyProjectParams = { ...assetSurveyProjectParams, with_new_field: assetType?.[0] === "with_new_field" ? true : false };
        // }

        if (isConverted) assetSurveyProjectParams = { ...assetSurveyProjectParams, ...isConverted };

        // Only the voice keys here; callers merge not_rejected in via buildAddonFilters
        return { ...assetSurveyProjectParams, ...buildAddonFilters(false, voiceAddon) };
    };

    const refreshRecommendationsList = (isAnalysis = false) => {
        const { addon_filters: voiceAddon, ...assetSurveyProjectParams } = applyFindParamsToMobileRecomParams(
            buildMobileRecomListParams(isAnalysis),
            params?.findParams
        );
        // The summary (/mobile-recom/summary) must see the same addon_filters as the list
        const addon_filters = buildAddonFilters(
            !assetSurveyProjectParams?.list?.survey_recommendations?.status?.some(s => s === 5 || s === "5"),
            voiceAddon
        );

        if (
            (section === "recommendationinfo" && getRecommendationByIdResponse?.project?.id) ||
            (section !== "recommendationinfo" && section !== "assetInfo" && (id || query?.pid)) ||
            (section === "assetInfo" && (getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid))
        ) {
            dispatch(
                actions.getAllMobileRecommendations({
                    ...assetSurveyProjectParams,
                    ...(section === "recommendationsinfo" && { recommendation_id: id }),
                    ...(section === "assetInfo" && { asset_id: id }),
                    ...addon_filters
                })
            );
        }
        dispatch(
            actions.getTableSummaryData({
                ...assetSurveyProjectParams,
                ...(section === "recommendationsinfo" && { recommendation_id: id }),
                ...(section === "assetInfo" && { asset_id: id }),
                ...addon_filters
            })
        );
    };

    const setFindParamsAndClearSelection = updater => {
        setSelectedRecomIds([]);
        setParams(prevParams => {
            const { recommendation_ids, ...rest } = typeof updater === "function" ? updater(prevParams) : updater;
            return rest;
        });
    };

    const applyFindParamsAfterReplace = nextFindParams => {
        setPendingFindParams(null);
        if (params?.findParams || nextFindParams) setFindParamsAndClearSelection(prevParams => ({ ...prevParams, findParams: nextFindParams }));
        else {
            setSelectedRecomIds([]);
            refreshRecommendationsList();
        }
    };

    const handlePerPageChange = async e => {
        const newPerPage = e.target.value;

        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            perPage: newPerPage,
            currentPage: 0
        }));

        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            limit: newPerPage
        }));
    };

    const handleMultiAssetUpdate = updateData => {
        const params = {
            ...updateData,
            ids: selectedRecomIds,
            client_id: getProjectByIdResponse?.client?.id,
            project_id: getProjectByIdResponse?.id
        };
        dispatch(actions.handleMultiMobileRecommendationUpdate(params));
        multiEditRef.current = true;
    };

    const renderMultiSelectEditForm = () => {
        if (!showMultiSelectEditForm) return null;
        return (
            <Portal
                body={
                    <RecommendationsMultiEdit
                        onCancel={() => {
                            setShowMultiSelectEditForm(false);
                        }}
                        selectedAssetsIds={selectedRecomIds}
                        handleMultiAssetUpdate={handleMultiAssetUpdate}
                        isMobileRecommendation
                        projectId={getProjectByIdResponse?.id}
                        clientId={getProjectByIdResponse?.client?.id}
                    />
                }
                onCancel={() => {
                    setShowMultiSelectEditForm(false);
                    setSelectedRecomIds([]);
                }}
            />
        );
    };
    const toggleSearchAndReplaceModal = () => setShowSearchAndReplaceModal(!showSearchAndReplaceModal);

    const renderSearchAndReplaceModal = () => {
        if (!showSearchAndReplaceModal) return null;

        const unsupportedTypes = [
            DYNAMIC_FIELD_TYPES.SELECT,
            "custom_select",
            DYNAMIC_FIELD_TYPES.BOOLEAN,
            DYNAMIC_FIELD_TYPES.NUMBER,
            DYNAMIC_FIELD_TYPES.DATE,
            DYNAMIC_FIELD_TYPES.DATE_TIME,
            DYNAMIC_FIELD_TYPES.COLOR,
            DYNAMIC_FIELD_TYPES.CURRENCY
        ];
        const formattedFields = (tableData?.keys ?? [])
            ?.filter(key => {
                const fieldConfig = tableData?.config?.[key] ?? {};
                const unprefixedKey = key?.startsWith("assets.") ? key?.split("assets.")?.[1] : key;
                return (
                    fieldConfig?.label &&
                    !unsupportedTypes.includes(fieldConfig?.type) &&
                    !fieldConfig?.rules?.read_only &&
                    !SEARCH_AND_REPLACE_REMOVED_FIELDS.includes(unprefixedKey) &&
                    !fieldConfig?.isYear
                );
            })
            ?.map(key => ({ label: tableData?.config?.[key]?.label, value: key }))
            .sort((a, b) => a.label.localeCompare(b.label));

        const getSearchAndReplaceParams = (data, isCount = false) => {
            const { limit, offset, order, jsonb_order, search: globalSearch, addon_filters: voiceAddon, ...baseParams } = buildMobileRecomListParams();

            return applyFindParamsToMobileRecomParams(
                {
                    ...baseParams,
                    ...buildAddonFilters(!baseParams?.list?.survey_recommendations?.status?.some(s => s === 5 || s === "5"), voiceAddon),
                    ...(selectedRecomIds?.length ? { selected_ids: selectedRecomIds } : { selected_ids: [] }),
                    ...data,
                    check_count: isCount
                },
                {
                    find: data?.search,
                    replace_fields: data?.replace_fields,
                    match_case: data?.match_case,
                    match_entire_cell: data?.match_entire_cell,
                    search_operator: data?.search_operator
                }
            );
        };

        const onSave = (data, isDelete) => {
            const nextFindParams = isDelete
                ? null
                : {
                      find: data?.replace,
                      replace_fields: data?.replace_fields,
                      match_case: data?.match_case,
                      match_entire_cell: data?.match_entire_cell,
                      search_operator: data?.search_operator
                  };
            dispatch(
                actions.searchAndReplaceMobileRecommendation(getSearchAndReplaceParams(data), response => {
                    const taskIds = [response?.task_id] ?? [];
                    if (taskIds?.length) {
                        setPendingFindParams({ findParams: nextFindParams });
                        setSearchReplaceTaskIds(taskIds);
                    } else applyFindParamsAfterReplace(nextFindParams);
                })
            );
        };

        const findBeforeReplace = (data, cb) => dispatch(actions.findMobileRecommendationsBeforeReplace(getSearchAndReplaceParams(data, true), cb));

        return (
            <Portal
                body={
                    <SearchAndReplace
                        onCancel={() => setShowSearchAndReplaceModal(false)}
                        tableFields={formattedFields}
                        handleSave={onSave}
                        loading={searchAndReplaceMobileRecomLoading || findMobileRecomBeforeReplacingLoading}
                        tableSearch={params?.findParams}
                        setFindParams={setFindParamsAndClearSelection}
                        findBeforeReplace={findBeforeReplace}
                        replaceCountResponse={findMobileRecomBeforeReplacingResponse}
                        replaceSuccessResponse={searchAndReplaceMobileRecomResponse}
                        setAlertMessage={setAlertMessage}
                        entityLabel={"Recommendation"}
                        entityPluralLabel={"Recommendations"}
                        isBgTask
                    />
                }
                onCancel={() => setShowSearchAndReplaceModal(false)}
            />
        );
    };

    const buildPath = basePath => {
        const incomingParams = new URLSearchParams(search || "");
        const params = new URLSearchParams();

        params.set("c_id", getProjectByIdResponse?.client?.id);
        const allowedKeys = ["is_assignedRecom", "pid", "is_verification"];

        allowedKeys.forEach(key => {
            if (incomingParams.has(key)) {
                params.set(key, incomingParams.get(key));
            }
        });

        return `${basePath}?${params.toString()}`;
    };
    const showInfoPage = (recommendationsId, omit, rowData, isCR = false) => {
        updateEntityParams(true);
        let newPath = buildPath(`/mobrecoms/mobrecomsinfo/${recommendationsId}/maindetails`);

        if (isNormalRecommendation) {
            newPath += `&is_NR=${isNormalRecommendation ?? false}`;
        }
        if (tableData?.data?.length) {
            addTableSliderDataToBreadcrumb(tableData?.data ?? []);
        }
        history.push(newPath);
    };

    const resetAll = async () => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        setParams(prevParams => ({
            ...prevParams,
            recommendation_ids: [],
            limit: 40,
            offset: 0,
            search: "",
            filters: null,
            order: null,
            list: null,
            idList: null,
            me: null,
            image_or_not: null,
            findParams: null
        }));

        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            perPage: 40,
            currentPage: 0
        }));
        setSelectedRowId(null);
        setTableLoading(false);
        setSelectedRecomIds([]);
        setIncompletedRecoms(0);
    };

    const isColunmVisibleChanged = () => {
        let flag = false;
        const { keys, config } = tableData;
        keys.forEach(key => {
            if (!_.isEqual(config[key]?.isVisible, initialTableConfig?.[key]?.isVisible)) {
                flag = true;
            }
        });
        return configChanged || flag;
    };

    const handleGlobalSearch = async search => {
        setShowGlobalSearchField(search ? true : false);
        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            search,
            recommendation_ids: []
        }));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: 0
        }));
        setSelectedRecomIds([]);
        setIncompletedRecoms(0);
    };

    const handleGoToColumn = async gotoKey => {
        if (gotoKey) {
            setSearchField(gotoKey);
            setHighlightSearchField(gotoKey);
        }
    };

    const resetAllFilters = async () => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        setParams(prevParams => ({
            ...prevParams,
            recommendation_ids: [],
            limit: 40,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            idList: null,
            me: null,
            image_or_not: null,
            findParams: null
        }));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            perPage: 40,
            currentPage: 0
        }));
        setSelectedRowId(null);
        setTableLoading(false);
        setSelectedRecomIds([]);
        setIncompletedRecoms(0);
    };

    const toggleWildCardFilter = () => {
        setShowWildCardFilter(!showWildCardFilter);
    };

    const resetSort = async () => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        setParams(prevParams => ({
            ...prevParams,
            order: null
        }));
        setTableLoading(false);
    };

    const updateSelectedRow = async (rowId, singleClick = false) => {
        setSelectedRowId(rowId);
        if (paneViewEnabled && (singleClick || !selectedPreviewId)) {
            setSelectedPreviewId(rowId);
        }
    };

    const updateLastSortFilter = async searchKey => {
        if (params.order && params?.order[searchKey]) {
            setParams({
                ...params,
                order: {
                    [searchKey]: params.order[searchKey] === "asc" ? "desc" : "asc"
                }
            });
        } else {
            setParams({
                ...params,
                order: { [searchKey]: searchKey === "survey_recommendations.surveyed_time" ? "asc" : "desc" }
            });
        }
        updateEntityParams();
    };

    const updateTableSortFilters = async searchKey => {
        if (params.order) {
            setParams(prevParams => ({
                ...prevParams,
                order: {
                    ...prevParams.order,
                    [searchKey]: prevParams.order[searchKey] === "desc" ? "asc" : "desc"
                }
            }));
        } else {
            setParams(prevParams => ({
                ...prevParams,
                order: { [searchKey]: "asc" }
            }));
        }
    };

    const handleHideColumn = async tableConfig => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        const { keys, config } = tableConfig;
        Object.keys(config)
            .filter(key => !config[key]?.isVisible && config[key]?.pinned)
            .forEach(key => {
                const { left, ...remainingStyles } = config[key]?.style || {};
                config[key] = {
                    ...config[key],
                    pinned: false,
                    style: remainingStyles
                };
            });
        const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            config[key] = {
                ...config[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        saveUserTableConfig(keys, config);
        setTableData(
            {
                ...tableData,
                keys,
                config
            },
            () => {
                updateEntityParams();
            }
        );
        setTableLoading(false);
    };

    const updateWildCardFilter = async newFilter => {
        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            filters: newFilter,
            recommendation_ids: []
        }));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: 0
        }));
        setSelectedRecomIds([]);
        setIncompletedRecoms(0);
        updateEntityParams();
    };

    const handlePageClick = async page => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: page.selected
        }));

        setParams(prevParams => ({
            ...prevParams,
            offset: page.selected
        }));
        setTableLoading(false);
    };

    const showEditPage = (rowId, row) => {
        addToBreadCrumpData({
            key: "edit",
            name: `Edit mobile recommendation`,
            path: `/mobrecoms/edit/${rowId}?c_id=${getProjectByIdResponse?.client?.id}`,
            isInnerTab: true
        });
        history.push(`/mobrecoms/edit/${rowId}?c_id=${getProjectByIdResponse?.client?.id}`);
        updateEntityParams(true);
    };

    function combineAndGroupFields(fields = {}, dynamicBand = {}) {
        let fieldsArray = Object.values(fields);
        let groupedFields = _.groupBy(fieldsArray, "group_field");

        for (let group in groupedFields) {
            groupedFields[group] = _.sortBy(groupedFields[group], "index");
        }

        let sortedGroups = {};
        Object.keys(dynamicBand)
            .sort((a, b) => dynamicBand[a] - dynamicBand[b])
            .forEach(key => {
                if (groupedFields?.[key]?.length)
                    sortedGroups[key] = (groupedFields?.[key] || [])?.reduce((acc, item) => {
                        acc = { ...acc, [item?.field_name]: item };
                        return acc;
                    }, {});
            });

        return sortedGroups;
    }

    const handleSelectRecom = async eachAsset => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        const tempAssetIds = selectedRecomIds?.includes(eachAsset?.id)
            ? selectedRecomIds?.filter(e => e !== eachAsset?.id)
            : [...selectedRecomIds, eachAsset?.id];
        setSelectedRecomIds([...tempAssetIds]);
        setTableLoading(false);
    };

    const handleSelectAllRecom = async checked => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        const tempRecommendationsList = tableData?.data || [];
        const everyAssetId = checked ? tableData?.data?.map(eachAsset => eachAsset?.id) : [];
        let tempSelected = [...selectedRecomIds];
        if (checked) {
            tempRecommendationsList?.forEach((item, idx) => {
                if (item?.status !== 4 && !tempSelected.some(t => t === item.id)) {
                    tempSelected.push(item.id);
                }
            });
        } else {
            tempSelected = selectedRecomIds;
            tempRecommendationsList.forEach((item, idx) => {
                tempSelected = tempSelected.filter(t => t !== item.id);
            });
        }
        setSelectedRecomIds([...tempSelected]);
        setTableLoading(false);
    };

    const clearSelection = () => {
        setSelectedRecomIds([]);
        const { recommendation_ids = [], ...rest } = params;
        setParams({ ...rest });
    };

    const showSelectedAssets = () => {
        let tempParams = params;
        if (params?.recommendation_ids?.length) {
            const { recommendation_ids, ...rest } = params;
            tempParams = rest;
        } else tempParams = { ...tempParams, recommendation_ids: selectedRecomIds, offset: 0, limit: 40 };
        setParams({ ...tempParams });
        setPaginationParams({ ...paginationParams, perPage: 40, currentPage: 0 });
    };

    const selectWholeAssets = () => {
        let { limit, offset, search: globalSearch, order, filters, recommendation_ids = [], list } = params;
        const { list: nonVoiceList, filters: nonVoiceFilters, addon: voiceAddon } = splitVoiceFilters({ list, filters });
        list = nonVoiceList;
        filters = nonVoiceFilters;
        let mobRecommendationFilterQuery =
            section === "recommendationsinfo"
                ? { "survey_recommendations.project_id": { filters: ["string_equals"], key: getRecommendationByIdResponse?.project?.id } }
                : section === "assetInfo"
                  ? {
                        "survey_recommendations.project_id": {
                            filters: ["string_equals"],
                            key: getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid
                        }
                    }
                  : {
                        "survey_recommendations.project_id": { filters: ["string_equals"], key: id || query?.pid },
                        ...(isSurveybasedRecoms
                            ? { "survey_recommendations.recommendation_survey_project_id": { filters: ["string_equals"], key: templateId } }
                            : {})
                    };

        let jsonb_filters;
        let jsonb_order;
        let jsonb_list;
        let assetType;

        const isDynamic = field => ["dynamic_fields"].includes(field?.split(".")?.[0]);

        Object.keys(list ?? {}).forEach(eachField => {
            if (isDynamic(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });
        const isAiFields = field => ["ai_flat_json"].includes(field?.split(".")?.[1]);
        Object.keys(list ?? {}).forEach(eachField => {
            if (isAiFields(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });

        let formattedList;
        let isConverted;

        Object.entries(list ?? {}).forEach(([key, value]) => {
            const field = key?.split(".")?.[0];
            const objectKey = key?.split(".")?.[1];
            if (field === "converted_or_not_converted") {
                isConverted = value?.length === 2 ? undefined : { converted_or_not_converted: value.includes("converted") };
            } else if (field === "status" || field === "has_new_val" || field === "survey_type") {
                formattedList = {
                    ...(formattedList ?? {}),
                    survey_recommendations: {
                        ...(formattedList?.survey_recommendations ?? {}),
                        [field]: [
                            ...(formattedList?.survey_recommendations?.[field] ?? []),
                            ...(field === "has_new_val" ? (value ?? [])?.map(v => v?.includes("With new field")) : value?.map(e => parseInt(e)))
                        ]
                    }
                };
            } else {
                formattedList = {
                    ...(formattedList ?? {}),
                    [field]: {
                        ...(formattedList?.[field] ?? {}),
                        [objectKey]: value
                    }
                };
            }
        });

        if (Object.keys(filters ?? {}).length) {
            Object.keys(filters).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_filters = { ...(jsonb_filters ?? {}), [e]: filters?.[e] };
                    const { [e]: omit, ...restFilters } = filters;
                    filters = { ...restFilters };
                }
            });
        }

        if (Object.keys(order ?? {}).length) {
            Object.keys(order).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_order = { ...(jsonb_order ?? {}), [e]: order?.[e] };
                    const { [e]: omit, ...restFilters } = order;
                    order = { ...restFilters };
                }
            });
        }

        let assetSurveyProjectParams = {
            search: globalSearch,
            order: order ?? {},
            limit,
            offset: offset + 1,
            filters: { ...mobRecommendationFilterQuery, ...filters },
            list: formattedList,
            jsonb_list,
            jsonb_filters,
            jsonb_order,
            report: true,
            ...(section === "recommendationsinfo" && { recommendation_id: id }),
            ...(!isSurveybasedRecoms ? { view_from: "projects" } : {}),
            ...(section === "assetInfo" && { asset_id: id }),
            ...(params?.image_or_not ? { image_or_not: params?.image_or_not } : {})
        };

        if (recommendation_ids?.length) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(formattedList ?? {}), survey_recommendations: { id: recommendation_ids } }
            };
        }

        if (params?.me) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(assetSurveyProjectParams?.list ?? {}), users: { id: [params.me] } }
            };
        }
        assetSurveyProjectParams = {
            ...assetSurveyProjectParams,
            ...buildAddonFilters(!assetSurveyProjectParams?.list?.survey_recommendations?.status?.some(s => s === 5 || s === "5"), voiceAddon)
        };

        // if (assetType?.length === 1) {
        //     assetSurveyProjectParams = { ...assetSurveyProjectParams, with_new_field: assetType?.[0] === "with_new_field" ? true : false };
        // }

        if (isConverted?.converted_or_not_converted === true) return;
        assetSurveyProjectParams = { ...assetSurveyProjectParams, converted_or_not_converted: false };

        assetSurveyProjectParams = applyFindParamsToMobileRecomParams(assetSurveyProjectParams, params?.findParams);

        dispatch(actions?.getAllMobileRecommendationIds(id || query?.pid, assetSurveyProjectParams));
    };

    const toggleFiltersPopup = () => {
        setShowFiltersPopup(!showFiltersPopup);
    };
    const submitMasterFilter = filterData => {
        const { filters, ...rest } = filterData || {};
        setParams({
            ...params,
            filters: Object.keys(filters || {})?.length ? filters : null,
            list: rest,
            idList:
                rest?.["survey_recommendations.status"] || rest?.["survey_recommendations.survey_type"]
                    ? {
                          ...(rest?.["survey_recommendations.status"] && {
                              ["survey_recommendations.status"]: rest?.["survey_recommendations.status"]
                          }),
                          ...(rest?.["survey_recommendations.survey_type"] && {
                              ["survey_recommendations.survey_type"]: rest?.["survey_recommendations.survey_type"]
                          })
                      }
                    : null,
            offset: 0
        });
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: 0
        }));
        setSelectedRecomIds([]);
        setIncompletedRecoms(0);
    };

    const renderFiltersPopup = () => {
        let { limit, offset, has_image, ...currentFilters } = { ...params };

        if (!showFiltersPopup) return null;
        return (
            <Portal
                body={
                    <MyFilters
                        onCancel={() => toggleFiltersPopup()}
                        currentFilters={{ ...currentFilters }}
                        submitMasterFilter={submitMasterFilter}
                        tableConfig={tableData.config}
                        surveyProjectFilterQuery={
                            section === "recommendationsinfo"
                                ? {
                                    //   ...(currentFilters?.filters ?? {}),
                                      "survey_recommendations.project_id": {
                                          filters: ["string_equals"],
                                          key: getRecommendationByIdResponse?.project?.id
                                      }
                                  }
                                : section === "assetInfo"
                                  ? {
                                        // ...(currentFilters?.filters ?? {}),
                                        "survey_recommendations.project_id": {
                                            filters: ["string_equals"],
                                            key: getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid
                                        }
                                    }
                                  : {
                                        // ...(currentFilters?.filters ?? {}),
                                        "survey_recommendations.project_id": { filters: ["string_equals"], key: id ?? query?.pid },
                                        ...(isSurveybasedRecoms
                                            ? {
                                                  "survey_recommendations.recommendation_survey_project_id": {
                                                      filters: ["string_equals"],
                                                      key: templateId
                                                  }
                                              }
                                            : {})
                                    }
                        }
                        recommendationId={section === "recommendationsinfo" ? { recommendation_id: id } : {}}
                        assetId={section === "assetInfo" ? { asset_id: id } : {}}
                    />
                }
                onCancel={() => toggleFiltersPopup()}
            />
        );
    };
    const renderAppliedFilters = () => {
        if (!showAppliedFilters) return null;

        const {
            "voice_upload.voice_text": voiceText,
            "voice_upload.voice_text_mobile": voiceTextMobile,
            has_voice_text: hasVoiceText,
            has_voice_text_mobile: hasVoiceTextMobile,
            ...restList
        } = params?.list ?? {};
        const {
            "voice_upload.voice_text": voiceTextFilter,
            "voice_upload.voice_text_mobile": voiceTextMobileFilter,
            ...restFilters
        } = params?.filters ?? {};
        const toYesNo = values => values?.map(v => (String(v) === "true" ? "Yes" : "No"));
        const toTranscript = (paramKey, ids) => ids?.map(id => appliedFilterNames?.[paramKey]?.[id] ?? id);
        const updatedParams = {
            ...params,
            filters: {
                ...restFilters,
                ...(voiceTextFilter ? { "Voice Transcript": voiceTextFilter } : {}),
                ...(voiceTextMobileFilter ? { "Mobile Voice Transcript": voiceTextMobileFilter } : {})
            },
            list: {
                ...restList,
                ["survey_recommendations.status"]: params?.list?.["survey_recommendations.status"]?.map(
                    id => recommendationSurveyStatus?.[id]?.value ?? id
                ),
                ["survey_recommendations.survey_type"]: params?.list?.["survey_recommendations.survey_type"]?.map(id => surveyTypes?.[id] ?? id),
                ...(voiceText ? { "Voice Transcript": toTranscript("voice_upload.voice_text", voiceText) } : {}),
                ...(voiceTextMobile ? { "Mobile Voice Transcript": toTranscript("voice_upload.voice_text_mobile", voiceTextMobile) } : {}),
                ...(hasVoiceText ? { "Has Voice Transcript": toYesNo(hasVoiceText) } : {}),
                ...(hasVoiceTextMobile ? { "Has Mobile Voice Transcript": toYesNo(hasVoiceTextMobile) } : {})
            }
        };

        return (
            <Portal
                body={
                    <AppliedFilters
                        myFilters={{}}
                        filterValues={updatedParams}
                        openFiltersPopup={() => setShowFiltersPopup(true)}
                        showFiltersIcon={!showFiltersPopup}
                        onCancel={() => setShowAppliedFilters(false)}
                        source="asset_survey"
                        tableConfig={tableData.config}
                    />
                }
                onCancel={() => setShowAppliedFilters(false)}
            />
        );
    };

    const updateImageComment = imageData => {
        const { image_ids = [], caption = "", id = "", description = "", captionchange = false, tags = [], removed_tags = [] } = imageData;
        dispatch(
            imageActions.updateImage({
                image_ids: id ? [id] : image_ids,
                caption: description ? description : caption,
                captionchange,
                tags,
                removed_tags
            })
        );
    };

    const getListForCommonFilter = async fieldParams => {
        let { search: globalSearch, filters, recommendation_ids = [], list, order } = params;
        const { list: nonVoiceList, filters: nonVoiceFilters, addon: voiceAddon } = splitVoiceFilters({ list, filters });
        list = nonVoiceList;
        filters = nonVoiceFilters;

        let mobRecommendationFilterQuery =
            section === "recommendationsinfo"
                ? { "survey_recommendations.project_id": { filters: ["string_equals"], key: getRecommendationByIdResponse?.project?.id } }
                : section === "assetInfo"
                  ? {
                        "survey_recommendations.project_id": {
                            filters: ["string_equals"],
                            key: getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid
                        }
                    }
                  : {
                        "survey_recommendations.project_id": { filters: ["string_equals"], key: id || query.pid },
                        ...(isSurveybasedRecoms
                            ? { "survey_recommendations.recommendation_survey_project_id": { filters: ["string_equals"], key: templateId } }
                            : {})
                    };

        let jsonb_filters;
        let jsonb_order;
        let jsonb_list;
        let assetType;

        const isDynamic = field => ["dynamic_fields"].includes(field?.split(".")?.[0]);

        if (list) {
            const { [fieldParams?.searchKey]: omit, ...restList } = list;
            list = restList;
        }

        Object.keys(list ?? {}).forEach(eachField => {
            if (isDynamic(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });
        const isAiFields = field => ["ai_flat_json"].includes(field?.split(".")?.[1]);
        Object.keys(list ?? {}).forEach(eachField => {
            if (isAiFields(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });
        if (Object.keys(order ?? {}).length) {
            Object.keys(order).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_order = { ...(jsonb_order ?? {}), [e]: order?.[e] };
                    const { [e]: omit, ...restFilters } = order;
                    order = { ...restFilters };
                }
            });
        }
        const search_filters = {};
        const jsonb_search_filters = {};
        Object.entries(fieldParams?.search_filters || {}).forEach(([key, value]) => {
            if (isDynamic(key) || isAiFields(key)) {
                jsonb_search_filters[key] = value;
            } else {
                search_filters[key] = value;
            }
        });

        let formattedList;
        let isConverted;

        Object.entries(list ?? {}).forEach(([key, value]) => {
            const field = key?.split(".")?.[0];
            const objectKey = key?.split(".")?.[1];
            if (field === "converted_or_not_converted") {
                isConverted = value?.length === 2 ? undefined : { converted_or_not_converted: value.includes("converted") };
            } else if (field === "status" || field === "has_new_val" || field == "survey_type") {
                formattedList = {
                    ...(formattedList ?? {}),
                    survey_recommendations: {
                        ...(formattedList?.survey_recommendations ?? {}),
                        [field]: [
                            ...(formattedList?.survey_recommendations?.[field] ?? []),
                            ...(field === "has_new_val" ? (value ?? [])?.map(v => v?.includes("With new field")) : value?.map(e => parseInt(e)))
                        ]
                    }
                };
            } else {
                formattedList = {
                    ...(formattedList ?? {}),
                    [field]: {
                        ...(formattedList?.[field] ?? {}),
                        [objectKey]: value
                    }
                };
            }
        });

        if (Object.keys(filters ?? {}).length) {
            Object.keys(filters).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_filters = { ...(jsonb_filters ?? {}), [e]: filters?.[e] };
                    const { [e]: omit, ...restFilters } = filters;
                    filters = { ...restFilters };
                }
            });
        }

        let assetSurveyProjectParams = {
            search: globalSearch,
            filters: { ...mobRecommendationFilterQuery, ...filters },
            list: formattedList,
            jsonb_list,
            jsonb_filters,
            jsonb_order,
            search_filters: search_filters ?? {},
            jsonb_search_filters: jsonb_search_filters ?? {},
            ...(section === "recommendationsinfo" && { recommendation_id: id }),
            ...(!isSurveybasedRecoms ? { view_from: "projects" } : {}),
            ...(section === "assetInfo" && { asset_id: id }),
            ...(params?.image_or_not ? { image_or_not: params?.image_or_not } : {})
        };

        if (recommendation_ids?.length) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(formattedList ?? {}), survey_recommendations: { id: recommendation_ids } }
            };
        }

        if (params?.me) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(assetSurveyProjectParams?.list ?? {}), users: { id: [params.me] } }
            };
        }

        assetSurveyProjectParams = {
            ...assetSurveyProjectParams,
            ...buildAddonFilters(
                !assetSurveyProjectParams?.list?.survey_recommendations?.status?.some(s => s === 5 || s === "5") && fieldParams.field !== "status",
                voiceAddon
            )
        };

        // if (assetType?.length === 1) {
        //     assetSurveyProjectParams = { ...assetSurveyProjectParams, with_new_field: assetType?.[0] === "with_new_field" ? true : false };
        // }

        if (isConverted) assetSurveyProjectParams = { ...assetSurveyProjectParams, ...isConverted };
        dispatch(
            actions.getListForMobileRecommendationFilter({
                ...assetSurveyProjectParams,
                field: fieldParams.field === "survey_recommendations.recommendation_source_type" ? "recommendation_source_type" : fieldParams.field
            })
        );
        return [];
    };

    const updateCommonFilter = async (list, exportParams) => {
        list = { ...(list ?? {}) };
        Object.keys(list ?? {}).forEach(eachKey => {
            if (!Object.keys(list?.[eachKey] ?? {}).length) {
                const { [eachKey]: omit, ...rest } = list;
                list = { ...rest };
            }
        });
        const exportParamKey = Object.keys(exportParams ?? {})?.[0];
        const allowedKeys = ["survey_recommendations.status", "survey_recommendations.survey_type"];
        const filteredExportParams = Object.fromEntries(Object.entries(exportParams || {})?.filter(([key]) => allowedKeys?.includes(key)));
        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            list,
            idList: {
                ...filteredExportParams
                // ...(params?.idList ?? {}),
                // ...(["status"].includes(exportParamKey ?? "") ? exportParams : {})
            },
            recommendation_ids: []
        }));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: 0
        }));
        setSelectedRecomIds([]);
        setIncompletedRecoms(0);
    };

    const exportTableXl = (isSummaryExport = false, surveyor_export = false) => {
        let { limit, offset, search: globalSearch, order, filters, recommendation_ids = [], list } = params;
        const { list: nonVoiceList, filters: nonVoiceFilters, addon: voiceAddon } = splitVoiceFilters({ list, filters });
        list = nonVoiceList;
        filters = nonVoiceFilters;
        let mobRecommendationFilterQuery =
            section === "recommendationsinfo"
                ? { "survey_recommendations.project_id": { filters: ["string_equals"], key: getRecommendationByIdResponse?.project?.id } }
                : section === "assetInfo"
                  ? {
                        "survey_recommendations.project_id": {
                            filters: ["string_equals"],
                            key: getDataByIdResponse?.project?.id ?? qs.parse(search)?.pid
                        }
                    }
                  : {
                        "survey_recommendations.project_id": { filters: ["string_equals"], key: id || query.pid },
                        ...(isSurveybasedRecoms
                            ? { "survey_recommendations.recommendation_survey_project_id": { filters: ["string_equals"], key: templateId } }
                            : {})
                    };

        let jsonb_filters;
        let jsonb_order;
        let jsonb_list;
        let assetType;

        const isDynamic = field => ["dynamic_fields"].includes(field?.split(".")?.[0]);

        Object.keys(list ?? {}).forEach(eachField => {
            if (isDynamic(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });
        const isAiFields = field => ["ai_flat_json"].includes(field?.split(".")?.[1]);
        Object.keys(list ?? {}).forEach(eachField => {
            if (isAiFields(eachField)) {
                jsonb_list = { ...(jsonb_list ?? {}), [eachField]: { value: list?.[eachField] } };
                const { [eachField]: omit, ...restList } = list;
                list = { ...restList };
            }
        });

        let formattedList;
        let isConverted;

        Object.entries(list ?? {}).forEach(([key, value]) => {
            const field = key?.split(".")?.[0];
            const objectKey = key?.split(".")?.[1];
            if (field === "converted_or_not_converted") {
                isConverted = value?.length === 2 ? undefined : { converted_or_not_converted: value.includes("converted") };
            } else if (field === "status" || field === "has_new_val" || field === "survey_type") {
                formattedList = {
                    ...(formattedList ?? {}),
                    survey_recommendations: {
                        ...(formattedList?.survey_recommendations ?? {}),
                        [field]: [
                            ...(formattedList?.survey_recommendations?.[field] ?? []),
                            ...(field === "has_new_val" ? (value ?? [])?.map(v => v?.includes("With new field")) : value?.map(e => parseInt(e)))
                        ]
                    }
                };
            } else {
                formattedList = {
                    ...(formattedList ?? {}),
                    [field]: {
                        ...(formattedList?.[field] ?? {}),
                        [objectKey]: value
                    }
                };
            }
        });

        if (Object.keys(filters ?? {}).length) {
            Object.keys(filters).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_filters = { ...(jsonb_filters ?? {}), [e]: filters?.[e] };
                    const { [e]: omit, ...restFilters } = filters;
                    filters = { ...restFilters };
                }
            });
        }

        if (Object.keys(order ?? {}).length) {
            Object.keys(order).forEach(e => {
                if (isDynamic(e) || isAiFields(e)) {
                    jsonb_order = { ...(jsonb_order ?? {}), [e]: order?.[e] };
                    const { [e]: omit, ...restFilters } = order;
                    order = { ...restFilters };
                }
            });
        }

        let assetSurveyProjectParams = {
            search: globalSearch,
            order: order ?? {},
            limit,
            offset: offset + 1,
            filters: { ...mobRecommendationFilterQuery, ...filters },
            list: formattedList,
            jsonb_list,
            jsonb_filters,
            jsonb_order,
            report: true,
            ...(section === "recommendationsinfo" && { recommendation_id: id }),
            ...(section === "assetInfo" && { asset_id: id }),
            // Export never sent not_rejected; only the voice keys are added here
            ...buildAddonFilters(false, voiceAddon)
        };

        if (recommendation_ids?.length) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(formattedList ?? {}), survey_recommendations: { id: recommendation_ids } }
            };
        }

        if (params?.me) {
            assetSurveyProjectParams = {
                ...assetSurveyProjectParams,
                list: { ...(assetSurveyProjectParams?.list ?? {}), users: { id: [params.me] } }
            };
        }

        // if (assetType?.length === 1) {
        //     assetSurveyProjectParams = { ...assetSurveyProjectParams, with_new_field: assetType?.[0] === "with_new_field" ? true : false };
        // }

        if (isConverted) assetSurveyProjectParams = { ...assetSurveyProjectParams, ...isConverted };

        assetSurveyProjectParams = applyFindParamsToMobileRecomParams(assetSurveyProjectParams, params?.findParams);

        let hide_recommendation_columns = [];
        Object.entries(tableData?.config ?? {}).forEach(([eachKey, eachField]) => {
            if (!eachField?.isVisible) {
                hide_recommendation_columns = [...hide_recommendation_columns, eachKey];
            }
        });
        if (isSummaryExport) {
            dispatch(
                actions.getMobileRecommendationsSummaryExports(
                    {
                        ...assetSurveyProjectParams,
                        hide_recommendation_columns,
                        ...(section === "recommendationsinfo" && { recommendation_id: id }),
                        ...(section === "assetInfo" && { asset_id: id }),
                        ...(surveyor_export ? { surveyor_export: true } : {}),
                        ...(!isSurveybasedRecoms ? { view_from: "projects" } : {}),
                        ...(params?.image_or_not ? { image_or_not: params?.image_or_not } : {})
                    },
                    surveyor_export ?? false
                )
            );
        } else
            dispatch(
                actions.getMobileRecommendationsExport({
                    ...assetSurveyProjectParams,
                    hide_recommendation_columns,
                    ...(section === "recommendationsinfo" && { recommendation_id: id }),
                    ...(!isSurveybasedRecoms ? { view_from: "projects" } : {}),
                    ...(section === "assetInfo" && { asset_id: id }),
                    ...(params?.image_or_not ? { image_or_not: params?.image_or_not } : {})
                })
            );
    };

    const toggleAppliedFiltersPopup = () => {
        setShowAppliedFilters(!showAppliedFilters);
    };

    const handleColumnPin = async keyItem => {
        const { config, keys } = tableData || {};
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 1));
        const { left, ...remainingStyles } = config[keyItem]?.style || {};
        const updatedConfig = {
            ...config,
            [keyItem]: {
                ...config[keyItem],
                pinned: !config[keyItem]?.pinned,
                style: config[keyItem]?.pinned
                    ? remainingStyles
                    : {
                          ...remainingStyles,
                          left: config[keyItem]?.style?.left || "auto"
                      }
            }
        };

        const pinnedColumns = keys.filter(key => updatedConfig[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });
        saveUserTableConfig(keys, updatedConfig);
        setTableData(
            {
                ...tableData,
                keys,
                config: updatedConfig
            },
            () => {
                updateEntityParams();
            }
        );
        setTableLoading(false);
    };
    const updateColumnWidthInConfig = (columnKey, style) => {
        const { keys, config } = tableData || {};

        const pinnedColumns = keys.filter(key => config[key]?.isVisible && config[key]?.pinned);
        const columnLeftValues = getPinnedColumnLeftPositions(pinnedColumns, pinnedColumnsRef);

        pinnedColumns.forEach(key => {
            config[key] = {
                ...config[key],
                style: {
                    ...config[key]?.style,
                    left: columnLeftValues[key] || "auto"
                }
            };
        });

        const updatedConfig = {
            ...config,
            [columnKey]: {
                ...config[columnKey],
                style: {
                    ...config[columnKey]?.style,
                    ...style
                }
            }
        };
        saveUserTableConfig(keys, updatedConfig);
        setTableData(
            {
                ...tableData,
                keys,
                config: updatedConfig
            },
            () => {
                updateEntityParams();
            }
        );
    };
    const unPinAllColumn = async () => {
        const { config, keys } = tableData;
        const updatedConfig = { ...config };
        keys.forEach(key => {
            updatedConfig[key] = {
                ...updatedConfig[key],
                pinned: false,
                style: {
                    ...config[key]?.style,
                    left: "auto"
                }
            };
        });
        setTableData({ ...tableData, config: updatedConfig });
    };
    const isEveryItemSelected = incompletedRecoms > 0 ? incompletedRecoms === selectedRecomIds?.length : false;

    const setMeFilter = () => {
        let surveyor = localStorage.getItem("userId");
        if (surveyor) setParams({ ...params, me: params?.me ? null : surveyor });
        else setAlertMessage("User id is not found");
    };

    const getAllImageList = () => {
        dispatch(surveyActions.getSurveyRecommendationImagesById(selectedPreviewId));
    };

    let isConsultancyUser = localStorage.getItem("role") === "consultancy_user";

    const renderProgressBarModal = () => {
        if (!progressBarModal) return null;
        return (
            <Portal
                body={
                    <ProgressBarModal
                        onClose={() => {
                            setProgressBarModal(false);
                            // dispatch(actions?.resetGroupEditReducer());
                        }}
                        data={
                            activeTaskId
                                ? backgroundTaskProgressResponse?.data?.id === activeTaskId
                                    ? backgroundTaskProgressResponse
                                    : {}
                                : backgroundTaskProgressResponse
                        }
                        refresh={() => {
                            if (activeTaskId) dispatch(actions?.getGroupEditProgress(activeTaskId));
                        }}
                        refreshTableData={() => {
                            const taskType = backgroundTaskProgressResponse?.data?.type ?? backgroundTaskProgressResponse?.data?.task_type;
                            if (taskType !== "search_and_replace") refreshRecommendationsList();
                        }}
                        taskId={activeTaskId}
                    />
                }
                onCancel={() => {
                    setProgressBarModal(false);
                    // dispatch(actions?.resetGroupEditReducer());
                }}
            />
        );
    };
    const toggleLineEditing = async () => {
        setTableLoading(true);
        await new Promise(resolve => setTimeout(resolve, 100));
        setLineEditingEnabled(prev => !prev);
        setTableLoading(false);
    };

    useEffect(() => {
        if (!lineEditingEnabled) return;
        const hasPriorityField = Object.values(tableData?.config ?? {}).some(each => each?.isPriorityElement);
        if (!hasPriorityField) return;

        const activeProjectId =
            section === "recommendationsinfo" ? getRecommendationByIdResponse?.project?.id : (query?.pid ?? projectId ?? id);
        if (!activeProjectId) return;

        const state = store.getState();
        if (!state?.recommendationsReducer?.priorityElementsDropDownResponse?.priority_elements?.length) {
            dispatch(normalRecomActions.getPriorityElementDropDownData(activeProjectId));
        }
        if (!state?.mobileRecommendationsReducer?.getMobileRecommendationDropdownResponse?.criticality_id?.length) {
            dispatch(actions.getMobileRecommendationDropdowns("criticality_id", activeProjectId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lineEditingEnabled, tableData?.config]);

    const getDropdownOptions = useCallback(
        async (keyItem, rowData = {}, search = "") => {
            const cellConfig = tableData?.config?.[keyItem] || {};
            const getMrDropDowns = () => store.getState()?.mobileRecommendationsReducer?.getMobileRecommendationDropdownResponse ?? {};

            if (cellConfig?.type === "boolean") {
                return [
                    { id: true, name: "Yes" },
                    { id: false, name: "No" }
                ];
            }

            const activeProjectId =
                section === "recommendationsinfo" ? getRecommendationByIdResponse?.project?.id : (query?.pid ?? projectId ?? id);

            if (cellConfig?.isPriorityElement) {
                const readPriorityElements = () =>
                    store.getState()?.recommendationsReducer?.priorityElementsDropDownResponse?.priority_elements ?? [];

                if (!readPriorityElements().length && activeProjectId) {
                    try {
                        await dispatch(normalRecomActions.getPriorityElementDropDownData(activeProjectId));
                    } catch (e) {
                        // fall through to the template-defined options below
                    }
                }

                const options = readPriorityElements().find(each => each?.id === keyItem)?.options;
                // LineEditDropdown labels dynamic options as value ?? name, so the score must go.
                const labelled = (options ?? []).map(({ value, ...rest }) => ({ ...rest, priority_element_option: value }));
                return normalizeLineEditOptions(labelled.length ? labelled : cellConfig?.options);
            }

            // Sourced from the status reducer, not the mobile recommendation service.
            if (keyItem === "recommendation_status_id") {
                if (!activeProjectId) return [];
                try {
                    await dispatch(normalRecomStatusActions.statusDropdown(activeProjectId));
                } catch (e) {
                    // fall through to the template-defined options below
                }
                const statusList = store.getState()?.recommendationStatusReducer?.getStatusDropdwnResponse?.recommendation_status_data;
                const usable = (statusList ?? []).filter(item => item?.key !== "deleted");
                return usable.length ? normalizeLineEditOptions(usable) : normalizeLineEditOptions(cellConfig?.options);
            }

            if (lineEditManufacturerFields.includes(keyItem)) {
                const clientId = getProjectByIdResponse?.client?.id;
                if (!clientId) return [];
                const currentUuid = rowData?.dynamic_fields?.[keyItem]?.uuid;
                try {
                    await dispatch(
                        normalAssetActions.getDropdownList("manufacturers", {
                            client_id: clientId,
                            ...(currentUuid ? { current_manufacturer: currentUuid } : {}),
                            ...(search ? { search } : {})
                        })
                    );
                } catch (e) {
                    // fall through to the template-defined options below
                }
                const manufacturers = store.getState()?.assetReducer?.dropDownList?.manufacturers;
                return normalizeLineEditOptions(manufacturers ?? cellConfig?.options);
            }

            const cachedOptions = normalizeLineEditOptions(getMrDropDowns()?.[keyItem]);
            if (cachedOptions.length) return cachedOptions;

            if (["select", "custom_select"].includes(cellConfig?.type) && lineEditFetchableDropdowns.includes(keyItem) && activeProjectId) {
                try {
                    await dispatch(actions.getMobileRecommendationDropdowns(keyItem, activeProjectId));
                } catch (e) {
                    // fall back to the template-defined options below
                }
            }

            const fetchedOptions = normalizeLineEditOptions(getMrDropDowns()?.[keyItem]);
            return fetchedOptions.length ? fetchedOptions : normalizeLineEditOptions(cellConfig?.options);
        },
        [
            tableData?.config,
            store,
            dispatch,
            projectId,
            id,
            section,
            getRecommendationByIdResponse,
            query?.pid,
            getProjectByIdResponse?.client?.id
        ]
    );

    const handleCellFocus = useCallback(
        async (keyItem, rowIndex, rowId = "", isDropdownLineEdit = false, rowData, search = "") => {
            const sameInputMode = isInputMode?.keyItem === keyItem && isInputMode?.rowIndex === rowIndex && isInputMode?.rowId === rowId;

            if (!isDropdownLineEdit) {
                if (!sameInputMode) setIsInputMode({ keyItem, rowIndex, rowId });
                return;
            }

            const loadingKey = `${rowIndex}::${keyItem}`;
            const isSearchable = !!tableData?.config?.[keyItem]?.hasSearchFunction;
            const cacheKey = isSearchable && search ? `${keyItem}::${search}` : keyItem;
            const cachedOptions = isSearchable && !search ? null : dropdownCacheRef.current[cacheKey];

            unstable_batchedUpdates(() => {
                if (!sameInputMode) setIsInputMode({ keyItem, rowIndex, rowId });
                setLineEditDropdownValue(cachedOptions ?? null);
                setIsDropdownLoading(cachedOptions ? null : loadingKey);
            });

            if (cachedOptions) return;

            lineEditFocusRef.current = keyItem;
            const options = await getDropdownOptions(keyItem, rowData, search);
            if (options?.length) dropdownCacheRef.current[cacheKey] = options;

            // A slower earlier request must not overwrite the field the user is now on.
            if (lineEditFocusRef.current !== keyItem) return;

            unstable_batchedUpdates(() => {
                // An empty array would shadow the template-defined options in Row, so hand back null instead.
                setLineEditDropdownValue(options?.length ? options : null);
                setIsDropdownLoading(null);
            });
        },
        [isInputMode, getDropdownOptions, tableData?.config]
    );

    const buildTemplateFieldMap = useCallback(() => {
        const rawTemplate = getMobileRecommendationTemplateResponse?.survey_recommendation_template?.dynamic_fields;
        if (!rawTemplate) return {};
        return Object.values(rawTemplate).reduce((accBands, bandData) => {
            const bandMap = (bandData?.fields ?? []).reduce((m, eachField) => {
                const item = Object.values(eachField)[0];
                if (item && item.field_name) m[String(item.field_name)] = item;
                return m;
            }, {});
            return { ...accBands, ...bandMap };
        }, {});
    }, [getMobileRecommendationTemplateResponse]);

    useEffect(() => {
        if (!lineEditRefreshRef?.current || !updateMobileRecommendationFieldsResponse) return;

        const { rowId, previousRow } = lineEditRefreshRef.current;
        const { success, message, detail = null } = updateMobileRecommendationFieldsResponse;

        if (success) {
            const statusValue = updateMobileRecommendationFieldsResponse?.data?.status;
            if (statusValue !== undefined && statusValue !== null) {
                setTableData(prevTableData => ({
                    ...prevTableData,
                    data: (prevTableData?.data ?? []).map(row => (row?.id === rowId ? { ...row, status: statusValue } : row))
                }));
            }
        } else {
            setTableData(prevTableData => ({
                ...prevTableData,
                data: (prevTableData?.data ?? []).map(row => (row?.id === rowId ? previousRow : row))
            }));
            setAlertMessage(typeof detail === "string" ? detail : message || "Unable to save the change. Please try again.");
        }

        lineEditRefreshRef.current = null;
    }, [updateMobileRecommendationFieldsResponse]);

    const saveLineEditValue = useCallback(
        (rowIndex, params, previousRow) => {
            const { id: rowId } = tableData?.data?.[rowIndex] || {};
            if (!rowId) return;
            dispatch(actions?.updateMobileRecommendationFields(rowId, params, "line_edit"));
            lineEditRefreshRef.current = { rowId, previousRow };
        },
        [tableData?.data, dispatch]
    );

    const handleCellValueChange = useCallback(
        (data, keyItem, rowIndex, _filterIdKey, isDropdownLineEdit = false, name, fieldConfig) => {
            const cellConfig = tableData?.config?.[keyItem] || {};
            if (!cellConfig?.isDynamicField) return;

            const currTableData = [...tableData.data];
            const previousRow = currTableData[rowIndex];
            const row = { ...previousRow };
            const rawValue = data[keyItem];
            const fieldType = fieldConfig?.type ?? cellConfig?.type;
            const isBooleanDropdown = fieldType === "boolean";
            const isMandatoryField = !!fieldConfig?.rules?.mandatory;

            let newValue;
            let newUuid = "";

            if (isDropdownLineEdit) {
                if (isBooleanDropdown) {
                    newValue = normalizeBooleanLineEditValue(rawValue);
                } else {
                    newValue = name != null ? String(name) : name;
                    newUuid = rawValue != null && rawValue !== "" ? String(rawValue) : "";
                }
            } else if (["date", "date_time", "string", "text", "memo"].includes(fieldType)) {
                newValue = rawValue;
            } else if (fieldType === "boolean") {
                newValue = normalizeBooleanLineEditValue(rawValue);
            } else if (["number", "currency", "year"].includes(fieldType)) {
                newValue = parseFloat(rawValue);
                if (isNaN(newValue)) newValue = rawValue || null;
            } else {
                newValue = rawValue || null;
            }

            const normalizedMandatoryValue = typeof newValue === "string" && fieldType !== "memo" ? newValue.trim() : newValue;
            const isEmptyMandatoryValue = isDropdownLineEdit
                ? isBooleanDropdown
                    ? normalizedMandatoryValue === null || normalizedMandatoryValue === ""
                    : normalizedMandatoryValue == null || normalizedMandatoryValue === "" || newUuid === ""
                : normalizedMandatoryValue == null || normalizedMandatoryValue === "";

            if (isMandatoryField && isEmptyMandatoryValue) return;

            const templateFieldMap = buildTemplateFieldMap();
            // Snapshot: the update loop below reassigns row.dynamic_fields per field.
            const preEditFields = { ...(row?.dynamic_fields ?? {}) };
            const getFieldState = fieldKey => preEditFields?.[fieldKey] || {};
            const resolveFieldKey = candidateKeys =>
                candidateKeys.find(
                    candidate => tableData?.config?.[candidate] || row?.dynamic_fields?.[candidate] || templateFieldMap?.[candidate]
                );

            const fieldUpdates = {
                [keyItem]: {
                    value: newValue,
                    uuid: isDropdownLineEdit && !isBooleanDropdown ? newUuid : (getFieldState(keyItem)?.uuid ?? "")
                }
            };

            const installedYearKey = resolveFieldKey(["installed_year", "assets.installed_year"]);
            const serviceLifeKey = resolveFieldKey(["service_life", "assets.service_life"]);
            const usefulLifeKey = resolveFieldKey(["usefull_life_remaining", "assets.usefull_life_remaining"]);
            const endOfServiceKey = resolveFieldKey(["end_of_service_life", "assets.end_of_service_life"]);
            const currentAgeKey = resolveFieldKey(["current_age", "assets.current_age"]);
            const isInstalledYearEdit = keyItem === installedYearKey;
            const isServiceLifeEdit = keyItem === serviceLifeKey;

            if (isInstalledYearEdit || isServiceLifeEdit) {
                const installedYear = isInstalledYearEdit ? newValue : getFieldState(installedYearKey)?.value;
                const serviceLife = isServiceLifeEdit ? newValue : getFieldState(serviceLifeKey)?.value;

                if (usefulLifeKey) fieldUpdates[usefulLifeKey] = { value: getUsefullLifeRemaining(installedYear, serviceLife), uuid: "" };
                if (endOfServiceKey) fieldUpdates[endOfServiceKey] = { value: getEndOfServiceLife(installedYear, serviceLife), uuid: "" };
                if (currentAgeKey && isInstalledYearEdit) fieldUpdates[currentAgeKey] = { value: getCurrentAge(installedYear), uuid: "" };
            }

            if (cellConfig?.isPriorityElement) {
                const priorityKeys = Object.keys(tableData?.config ?? {}).filter(key => tableData?.config?.[key]?.isPriorityElement);
                const priorityElements = store.getState()?.recommendationsReducer?.priorityElementsDropDownResponse?.priority_elements ?? [];

                const scoreFor = fieldKey => {
                    const selectedUuid = fieldKey === keyItem ? newUuid : getFieldState(fieldKey)?.uuid;
                    if (!selectedUuid) return 0;
                    const option = priorityElements.find(each => each?.id === fieldKey)?.options?.find(opt => opt?.id === selectedUuid);
                    return Number(option?.value) || 0;
                };

                const priorityTotal = priorityKeys.reduce((sum, fieldKey) => sum + scoreFor(fieldKey), 0);
                const priorityTotalKey = resolveFieldKey(["priority"]);
                if (priorityTotalKey) fieldUpdates[priorityTotalKey] = { value: priorityTotal, uuid: "" };

                // Absent setting means "priority", matching MiscSettings; "year" projects keep theirs.
                const criticalityKey = resolveFieldKey(["criticality_id"]);
                const criticalityRanges = store.getState()?.mobileRecommendationsReducer?.getMobileRecommendationDropdownResponse?.criticality_id;
                const { criticality_score = "priority" } = getProjectByIdResponse?.miscellaneous ?? {};
                if (criticalityKey && priorityTotal > 0 && criticalityRanges?.length && criticality_score !== "year") {
                    const match = criticalityRanges.find(
                        each => priorityTotal >= Number(each?.start_range) && priorityTotal <= Number(each?.end_range)
                    );
                    fieldUpdates[criticalityKey] = { value: match?.name ?? "", uuid: match?.id ?? "" };
                }
            }

            const logFields = {};
            const dynamicFieldsPayload = {};

            Object.entries(fieldUpdates).forEach(([fieldKey, update]) => {
                if (fieldKey?.startsWith?.("survey_details.")) return;
                const fieldConfigForKey = tableData?.config?.[fieldKey] || {};
                const templateFieldFull = templateFieldMap?.[fieldKey] || {};
                const selectedField = getFieldState(fieldKey);
                const fieldLabel = fieldConfigForKey?.label ?? templateFieldFull?.label ?? fieldKey;

                row.dynamic_fields = {
                    ...(row.dynamic_fields || {}),
                    [fieldKey]: {
                        ...(row.dynamic_fields?.[fieldKey] || {}),
                        value: update.value,
                        uuid: update.uuid ?? "",
                        label: row?.dynamic_fields?.[fieldKey]?.label ?? fieldLabel,
                        invalid: row?.dynamic_fields?.[fieldKey]?.invalid ?? selectedField?.invalid ?? false
                    }
                };

                if (_.isEqual(selectedField?.value, update.value) && _.isEqual(selectedField?.uuid ?? "", update.uuid ?? "")) return;

                logFields[fieldKey] = {
                    value: update.value,
                    uuid: update.uuid ?? "",
                    invalid: selectedField?.invalid ?? false,
                    old_value: {
                        value: selectedField?.value ?? "",
                        uuid: selectedField?.uuid ?? "",
                        invalid: selectedField?.invalid ?? false,
                        label: selectedField?.label ?? templateFieldFull?.label ?? fieldLabel
                    }
                };
                dynamicFieldsPayload[fieldKey] = {
                    ...templateFieldFull,
                    field_name: fieldKey,
                    value: update.value,
                    uuid: update.uuid ?? ""
                };
            });

            currTableData[rowIndex] = row;
            setTableData(prev => ({ ...prev, data: currTableData }));

            if (!Object.keys(logFields).length) return;

            saveLineEditValue(rowIndex, { log_fields: logFields, dynamic_fields: dynamicFieldsPayload }, previousRow);
        },
        [
            tableData?.config,
            tableData?.data,
            buildTemplateFieldMap,
            saveLineEditValue,
            store,
            getProjectByIdResponse?.miscellaneous?.criticality_score
        ]
    );

    const lineEditRefs = useRef({});
    lineEditRefs.current.handleCellFocus = handleCellFocus;
    lineEditRefs.current.handleCellValueChange = handleCellValueChange;

    const stableHandleCellFocus = useCallback((...args) => lineEditRefs.current.handleCellFocus(...args), []);
    const stableHandleCellValueChange = useCallback((...args) => lineEditRefs.current.handleCellValueChange(...args), []);

    const isTableDataLoading =
        getMobileRecommendationsResponse?.isLoading ||
        getMobileRecommendationTemplateResponse?.isLoading ||
        params?.isConfigLoading ||
        (tableLoading && !assetTableAiAnalysisClick);

    const tableDataWithStickyAssetLeft = useMemo(() => getTableDataWithStickyAssetLeft(tableData, "status"), [tableData]);
    const renderTable = useMemo(() => {
        return (
            <Table
                tableData={tableDataWithStickyAssetLeft}
                hasDelete={false}
                hasInfoPage={true}
                updateSelectedRow={updateSelectedRow}
                hasEdit={
                    !isNormalRecommendation &&
                    (isSurveybasedRecoms ? checkPermission("forms", permissions.MR_RECOMMENDATION, "edit") : projectManagementEditPermission)
                }
                hasViewIcon
                showInfoPage={showInfoPage}
                tableParams={params}
                findAndReplaceParams={params?.findParams}
                updateTableSortFilters={updateTableSortFilters}
                handleHideColumn={handleHideColumn}
                wildCardFilter={params.filters}
                showWildCardFilter={showWildCardFilter}
                updateWildCardFilter={updateWildCardFilter}
                showEditPage={showEditPage}
                clientId={getProjectByIdResponse?.client?.id ?? ""}
                hasMultiAction
                handleSelectRecom={handleSelectRecom}
                selectedRecomIds={selectedRecomIds}
                handleSelectAllRecom={handleSelectAllRecom}
                everyItemCheckedPerPage={(() => {
                    const selectableRows = tableData?.data?.filter(item => item?.status !== 4) ?? [];
                    return selectableRows?.length > 0 && selectableRows.every(item => selectedRecomIds.find(e => e === item.id));
                })()}
                pinnedColumnsRef={pinnedColumnsRef}
                selectedRowId={selectedRowId}
                handleSurveyAssetStatus={handleSurveyAssetStatus}
                getListForCommonFilter={getListForCommonFilter}
                commonFilterData={getListForMobileRecommendationCommonFilterResponse}
                commonFilter={params?.list}
                updateCommonFilter={updateCommonFilter}
                isNewTableFilters
                exportFilters={params?.idList}
                hasPin={true}
                unPinAllColumn={unPinAllColumn}
                handleColumnPin={handleColumnPin}
                updateColumnWidthInConfig={updateColumnWidthInConfig}
                additionalTableClass={`resize-icon-st ${lineEditingEnabled ? "overf-fullscreen-hght" : ""}`}
                isInputMode={isInputMode}
                handleCellFocus={stableHandleCellFocus}
                handleCellValueChange={stableHandleCellValueChange}
                lineEditingEnabled={lineEditingEnabled}
                lineEditDropdownValue={lineEditDropdownValue}
                isDropdownLoading={isDropdownLoading}
                parentLoading={parentLoading || isTableDataLoading}
                OnPaneViewClick={onPaneViewClick}
                paneViewEnabled={paneViewEnabled}
                hasPaneView
                commonTableClassName={` search-wrp-ht ${showGlobalSearchField ? "search-fil-wrap" : ""} ${
                    selectedRecomIds?.length ? "filter-wrp-ht" : ""
                } ${(showMoreFilter && selectedRecomIds?.length) || selectedRecomIds?.length ? "asset-top-filter" : ""}  ${showMoreFilter ? " mobile-asset-more-filter" : ""} mobile-recom-table ${isSurveybasedRecoms ? "mobile-survey-recom-table" : ""} `}
                hasSearchApi={true}
                isSurveyRecom={true}
                tableRef={tableRef}
                highlightSearchField={highlightSearchField}
                searchField={searchField}
                setSearchField={() => {
                    setSearchField(null);
                }}
                isSurveybasedRecoms={isSurveybasedRecoms}
            />
        );
    }, [
        tableDataWithStickyAssetLeft,

        selectedRecomIds,
        params,
        selectedRowId,
        showWildCardFilter,
        getListForMobileRecommendationCommonFilterResponse,
        paneViewEnabled,
        searchField,
        showMoreFilter,
        showGlobalSearchField,
        isInputMode,
        lineEditingEnabled,
        lineEditDropdownValue,
        isDropdownLoading,
        parentLoading,
        isTableDataLoading
    ]);

    const renderAnalysisConfirmation = () => {
        if (!showAnalysisConfirm) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            <div>
                                Do you want to run AI analysis on{" "}
                                {selectedRecomIds?.length || paginationParams?.totalCount ? (
                                    <span className="badge-red-circled pl-2 pr-2 m-0" style={{ minWidth: "20px", maxWidth: "100px", width: "auto" }}>
                                        {selectedRecomIds?.length || paginationParams.totalCount || ""}
                                    </span>
                                ) : (
                                    "all"
                                )}{" "}
                                {selectedRecomIds?.length
                                    ? selectedRecomIds?.length > 1
                                        ? "recommendations"
                                        : "recommendation"
                                    : (paginationParams?.totalCount || 1) > 1
                                      ? "recommendations"
                                      : "recommendation"}
                                ?
                            </div>
                        }
                        message={
                            <div>
                                This will analyze{" "}
                                {selectedRecomIds?.length || paginationParams?.totalCount ? (
                                    <span
                                        className="badge-red-circled pl-2 pr-2 ml-0 mr-0"
                                        style={{ minWidth: "20px", maxWidth: "100px", width: "auto" }}
                                    >
                                        {selectedRecomIds?.length || paginationParams.totalCount || ""}
                                    </span>
                                ) : (
                                    "all"
                                )}{" "}
                                {selectedRecomIds?.length
                                    ? selectedRecomIds?.length > 1
                                        ? "recommendations"
                                        : "recommendation"
                                    : (paginationParams?.totalCount || 1) > 1
                                      ? "recommendations"
                                      : "recommendation"}
                                , even if they have been analyzed previously. This process will take time to get completed.{" "}
                                <div>
                                    <b>Do you want to continue?</b>
                                </div>
                            </div>
                        }
                        onNo={() => setAnalysisConfirmation(false)}
                        onYes={() => {
                            dispatch(surveyActions?.assetTableAiAnalyse(true));
                            refreshRecommendationsList(true);
                            setAnalysisConfirmation(false);
                        }}
                    />
                }
                onCancel={() => setAnalysisConfirmation(false)}
            />
        );
    };
    const toggleTableSummary = () => {
        setShowTableSummary(!showTableSummary);
    };

    const renderTableSummary = () => {
        if (!showTableSummary) return null;
        return (
            <Portal body={<MobileTableSummary toggleTableSummary={toggleTableSummary} getTableSummaryDataResponse={getTableSummaryDataResponse} />} />
        );
    };
    const toggleMoreFilter = async data => {
        setShowMoreFilter(!showMoreFilter);
    };
    const filterByAnyKey = (key, value) => {
        setParams({
            ...params,
            offset: 0,
            [key]: value
        });
        setSelectedRecomIds([]);
        updateEntityParams();
    };
    const selectedAsset = tableData?.data?.find(e => e.id === selectedPreviewId);
    const memoizedProjectId = useMemo(
        () => getMobileRecommendationByIdResponse?.recommendation?.project?.id ?? projectId,
        [getMobileRecommendationByIdResponse, projectId]
    );

    const memoizedBasicDetails = useMemo(() => basicDetails, [basicDetails]);
    const memoizedAssetsForm = useMemo(() => {
        return <AssetsForm isMobileRecommendation basicDetails={memoizedBasicDetails} projectId={memoizedProjectId} />;
    }, [memoizedBasicDetails, memoizedProjectId]);

    const exportPopup = () => (
        <Dropdown className="export-btn-drop mr-2 mobile-recom-export-popup" show={showExcelPopup}>
            <Dropdown.Toggle id="dropdown-basic" onClick={() => setShowExcelPopup(!showExcelPopup)} className="add-btn ml-2 btn-new-noti export-btn">
                {getMobileRecommendationsExcelLoading?.isLoading ? (
                    <div className="spinner-border text-primary mr-1" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                ) : (
                    <div className="view-inner" data-for={"table top icons"} data-tip={"Mobile Recommendations Statistics"}>
                        <img src="/img/excell-new.svg" alt="" className="export export-all-trades" />
                    </div>
                )}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item>Excel</Dropdown.Item>
                <div class="brief-desc flex-wrap print-recom-mode">
                    <div class="seting-type checkbox-container print-mode">
                        <label class="container-checkbox cursor-hand">
                            <input type="checkbox" checked={!surveyExport} onChange={e => setSurveyExport(false)} />
                            <span class="checkmark"></span>Mobile Recom. Summary
                        </label>
                        <label class="container-checkbox cursor-hand">
                            <input type="checkbox" checked={surveyExport} onChange={e => setSurveyExport(true)} />
                            <span class="checkmark"></span>Mobile Recom. Surveyor Summary
                        </label>
                    </div>
                    <button
                        className="dwd-btn mt-3"
                        onClick={() => {
                            exportTableXl(true, surveyExport);
                            setShowExcelPopup(false);
                        }}
                    >
                        <i className="fas fa-file-download mr-2"></i>
                        Download
                    </button>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );

    return (
        <>
            <LoadingOverlay
                active={isTableDataLoading && !parentLoading}
                spinner={<Loader />}
                fadeSpeed={10}
            >
                {section === "edit" ? (
                    memoizedAssetsForm
                ) : (
                    <>
                        {/* <div className="tab-active recomdn-table bg-grey-table"> */}
                        <div
                            className={`dtl-sec rcom-tot-dtl mobile-recom-table-wrap col-md-12 mb-4 ${
                                lineEditingEnabled ? "fullscreen-table" : ""
                            }`}
                        >
                            <div className="table-top-menu allign-right">
                                <div className="lft">
                                    <button
                                        className="btn btn-reset-fl-cmn refresh-btn-hght  btm-mar-rc"
                                        type="button"
                                        onClick={e => {
                                            e.preventDefault();
                                            refreshRecommendationsList();
                                        }}
                                    >
                                        <span className="icon mr-1">
                                            <img src={refreshIcon} alt="" />
                                        </span>
                                        <span className="text">Refresh</span>
                                    </button>
                                </div>
                                <div className="rgt justify-content-between">
                                    <TableTopIcons
                                        tableData={tableData}
                                        resetAll={resetAll}
                                        isColunmVisibleChanged={isColunmVisibleChanged}
                                        globalSearchKey={params.search}
                                        handleGlobalSearch={handleGlobalSearch}
                                        resetAllFilters={resetAllFilters}
                                        toggleWildCardFilter={toggleWildCardFilter}
                                        showViewModal={() => setShowViewModal(!showViewModal)}
                                        resetSort={resetSort}
                                        tableParams={params}
                                        isExport={
                                            isSurveybasedRecoms
                                                ? checkPermission("forms", permissions.MR_RECOMMENDATION, "export")
                                                : (checkPermission("forms", permissions.MR_RECOMMENDATION, "export") &&
                                                      (user_role === "super_admin"
                                                          ? true
                                                          : !checkPermission("forms", "recom_mgmt_mobile", "view"))) ||
                                                  (checkPermission("forms", "recom_mgmt_mobile", "export") &&
                                                      checkPermission("forms", "recom_mgmt_mobile", "view") &&
                                                      checkPermission("forms", permissions.MR_RECOMMENDATION, "export"))
                                        }
                                        showWildCardFilter={showWildCardFilter}
                                        hasWildCardFilter
                                        updateLastSortFilter={updateLastSortFilter}
                                        openFiltersPopup={toggleFiltersPopup}
                                        toggleAppliedFiltersPopup={toggleAppliedFiltersPopup}
                                        exportTableXl={exportTableXl}
                                        hasNewlyCreated
                                        hasNewlyEdited
                                        resetAllTableConfig={resetAllTableConfig}
                                        hasMeFilter={isConsultancyUser}
                                        setMeFilter={setMeFilter}
                                        hasAIAnalyse={checkPermission("forms", "bulk_ai_analysis", "create")}
                                        analysisLoading={assetTableAiAnalysisClick ?? false}
                                        onAnalysis={() => {
                                            setAnalysisConfirmation(true);
                                        }}
                                        mobileRecom
                                        showTableSummary
                                        toggleTableSummary={toggleTableSummary}
                                        tableSummaryLoading={getTableSummaryDataLoading}
                                        exportPopup={() =>
                                            checkPermission("forms", "mobile_recommendation_statitics", "export") ? exportPopup() : false
                                        }
                                        tableLoading={getExcelLoading ?? false}
                                        groupEditProgressClick={() => {
                                            setProgressBarModal(true);
                                        }}
                                        showMultiEditPorgress={
                                            activeTaskId &&
                                            backgroundTaskProgressResponse?.data?.id === activeTaskId &&
                                            backgroundTaskProgressResponse?.data?.status !== 3
                                        }
                                        progressFailed={Number(backgroundTaskProgressResponse?.data?.status) === 4}
                                        progressPercent={backgroundTaskProgressResponse?.data?.result?.data_update_percent ?? null}
                                        hasGoToFunctionality={true}
                                        hasSurveyedDate
                                        toggleMoreFilter={toggleMoreFilter}
                                        hasAdditionalFilters={true}
                                        additionalFilterTooltip={"More Filters"}
                                        isMoreFiltered={() => (params?.image_or_not ? true : false)}
                                        setShowGlobalSearchField={value => {
                                            setShowGlobalSearchField(value);
                                        }}
                                        showGlobalSearchField={showGlobalSearchField}
                                        hasSearchAndReplace={checkPermission("forms", permissions.MR_RECOMMENDATION_SEARCH_REPLACE, "edit")}
                                        toggleSearchAndReplaceModal={toggleSearchAndReplaceModal}
                                        isFound={params?.findParams}
                                        hasTableCellEdit={
                                            !isNormalRecommendation && checkPermission("forms", permissions.MR_RECOMMENDATION, "line_edit")
                                        }
                                        lineEditingEnabled={lineEditingEnabled}
                                        toggleLineEditing={toggleLineEditing}
                                    />
                                </div>
                            </div>
                            <div className="d-flex wrapper-icon-full">
                                {selectedRecomIds?.length > 0 && (
                                    <>
                                        <button className={"add-btn ml-2 btn-new-noti"} onClick={e => e.preventDefault()}>
                                            <i className="fas fa-check" />
                                            <span>{selectedRecomIds?.length}</span>
                                        </button>
                                        <button
                                            className={"add-btn ml-2 btn-new-noti"}
                                            onClick={e => {
                                                e.preventDefault();
                                                clearSelection();
                                            }}
                                        >
                                            <i className="fas fa-times-circle mr-1" /> {`Clear`}
                                        </button>
                                        {(
                                            isSurveybasedRecoms
                                                ? checkPermission("forms", "mobile_recommendations", "edit")
                                                : projectManagementEditPermission
                                        ) ? (
                                            <button className={"add-btn ml-2 btn-new-noti"} onClick={() => setShowMultiSelectEditForm(true)}>
                                                <i className="fas fa-pencil-alt mr-1" /> {`Edit`}
                                            </button>
                                        ) : null}
                                        <button
                                            className={"add-btn ml-2 btn-new-noti"}
                                            onClick={e => {
                                                e.preventDefault();
                                                showSelectedAssets();
                                            }}
                                        >
                                            <i className="fas fa-eye mr-1" />
                                            {params?.recommendation_ids?.length ? " Show All" : " Show"}
                                        </button>
                                        {paginationParams?.totalCount > paginationParams?.perPage && (
                                            <button
                                                className={`mobile-recom-select-btn add-btn ml-2 btn-new-noti btn-sel-all ${
                                                    isEveryItemSelected ? "active" : ""
                                                }`}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    selectWholeAssets();
                                                }}
                                            >
                                                <i className="fas fa-check-double mr-1" /> {isEveryItemSelected ? "Selected All" : "Select All"}{" "}
                                                {isEveryItemSelected && (
                                                    <span>
                                                        {incompletedRecoms} / {paginationParams?.totalCount}
                                                    </span>
                                                )}
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                            <div class={`collapse-outer col-md-12 p-0  ${showMoreFilter ? "tog-cls" : ""} `}>
                                <TableTopMoreFilters tableParams={params} hasImageFilter={true} filterByAnyKey={filterByAnyKey} />
                            </div>
                            <div className="d-flex recommendations-table">
                                {renderTable}
                                {selectedAsset?.id && (
                                    <RecommendationPreview
                                        selectedRecom={selectedAsset || {}}
                                        imageList={previewImageList}
                                        getAllImageList={getAllImageList}
                                        onPreviewCancel={onPaneViewClose}
                                        isSurveyAsset
                                        isMobileRecommendation
                                        // deleteImage={deleteImage}
                                        updateImage={updateImageComment}
                                        hasCaptionEdit={false}
                                        outerDivClassName={`${showGlobalSearchField ? "search-fil-wrap" : ""} ${
                                            selectedRecomIds?.length ? "filter-wrp-ht" : ""
                                        } ${(showMoreFilter && selectedRecomIds?.length) || selectedRecomIds?.length ? "asset-top-filter" : ""}  ${showMoreFilter ? " mobile-asset-more-filter" : ""} initial-mobile-recom`}
                                    />
                                )}
                            </div>
                            {tableData?.data && tableData?.data?.length ? (
                                <div className="table-bottom d-flex">
                                    <div className="count d-flex col-md-6">
                                        <div className="count-dtl">
                                            Total Count: <span>{paginationParams.totalCount}</span>
                                        </div>
                                        <div className="col-md-2 pr-2 selbx">
                                            <select className="form-control" value={paginationParams.perPage} onChange={e => handlePerPageChange(e)}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="40">40</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="150">150</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="pagination-sec col-md-6">
                                        <ReactPaginate
                                            previousLabel={
                                                <span data-place="top" data-effect="solid" data-tip={`Previous`} data-background-color="#007bff">
                                                    &lt;
                                                </span>
                                            }
                                            nextLabel={
                                                <span data-place="top" data-effect="solid" data-tip={`Next`} data-background-color="#007bff">
                                                    &gt;
                                                </span>
                                            }
                                            breakLabel={"..."}
                                            breakClassName={"break-me"}
                                            pageCount={paginationParams.totalPages}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            activeLinkClassName={"active"}
                                            forcePage={paginationParams.currentPage}
                                        />
                                        <ReactTooltip />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {showViewModal ? (
                            <Portal
                                body={
                                    <DynamicColumnModal
                                        tableData={tableData}
                                        handleHideColumn={handleHideColumn}
                                        onCancel={() => {
                                            setShowViewModal(false);
                                        }}
                                        handleGoToColumn={handleGoToColumn}
                                    />
                                }
                                onCancel={() => setShowViewModal(false)}
                            />
                        ) : null}
                        {/* </div> */}
                    </>
                )}
            </LoadingOverlay>
            {renderMultiSelectEditForm()}
            {renderFiltersPopup()}
            {renderAppliedFilters()}
            {renderAnalysisConfirmation()}
            {renderTableSummary()}
            {renderProgressBarModal()}
            {renderSearchAndReplaceModal()}
        </>
    );
};

export default MobileRecommendationsMain;
